export const en = {
  // Header
  header: {
    search: 'Search',
    myAccount: 'My Account',
    login: 'Sign In',
    account: 'Account',
    wishlist: 'Wishlist',
    cart: 'Cart',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    goTo: 'Go to',
    show: 'Show',
    products: 'products',
    contact: 'Contact',
    productFilters: 'Product Filters',
    clearFilters: 'Clear filters',
    category: 'Category',
    skinType: 'Skin Type',
    priceRange: 'Price Range',
    applyFilters: 'Apply Filters',
    allProducts: 'All Products',
    all: 'All',
    selectCategory: 'Select category',
    selectSkinType: 'Select skin type',
  },
  
  // Footer
  footer: {
    description: 'Premium beauty and skincare products, specially selected to reveal your natural beauty.',
    productsBySkinType: 'Products by Skin Type',
    help: 'Help',
    blog: 'Blog',
    contacts: 'Contact',
    delivery: 'Delivery',
    returns: 'Returns',
    faq: 'FAQ',
    allRightsReserved: 'All rights reserved',
    privacyPolicy: 'Privacy Policy',
    termsOfUse: 'Terms of Use',
    cookiePolicy: 'Cookie Policy',
  },

  // Cookie Banner
  cookies: {
    title: 'Cookie Settings',
    description: 'We use cookies to improve your browsing experience, analyze site traffic, and personalize content. You can choose which cookies to allow.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Non-Essential',
    settings: 'Settings',
    moreInfo: 'More information:',
    categoriesTitle: 'Cookie Categories',
    necessary: 'Necessary Cookies',
    necessaryBadge: 'Required',
    necessaryDescription: 'Required for website functionality and security',
    functional: 'Functional Cookies',
    optionalBadge: 'Optional',
    functionalDescription: 'Improve website functionality and user experience',
    analytics: 'Analytics Cookies',
    analyticsDescription: 'Help understand how you use the site (Google Analytics)',
    marketing: 'Marketing Cookies',
    marketingDescription: 'Used for personalized advertising and retargeting',
    saveSettings: 'Save Settings',
    back: 'Back',
    closeSettings: 'Close cookie settings',
    saveSelected: 'Save selected cookie settings',
    backToMain: 'Back to main cookie banner',
    acceptAllLabel: 'Accept all cookies',
    rejectAllLabel: 'Reject all non-essential cookies',
    openSettings: 'Open cookie settings',
  },
  
  // Blog
  blog: {
    title: 'Beauty and Skincare',
    titleHighlight: 'Blog',
    description: 'Expert advice, product reviews and news from the beauty world',
    featured: 'Featured Article',
    readArticle: 'Read Article',
    readMore: 'Read More',
    noResults: 'No articles found for selected filters',
    newsletterTitle: 'Get beauty tips straight to your inbox',
    newsletterDescription: 'Subscribe to our newsletter for exclusive offers and tips',
    clearFilters: 'Clear filters',
    ctaTitle: 'Ready to find your ideal products?',
    ctaDescription: 'Browse our carefully curated beauty product collection',
    ctaButton: 'View Products',
    relatedPosts: 'Related Articles',
    backToBlog: 'Back to Blog',
    share: 'Share',
    articleNotFound: 'Article not found',
  },
  
  // Newsletter
  newsletter: {
    title: 'Get beauty tips and exclusive offers',
    description: 'Join our beauty community and be the first to know about new products, exclusive offers and professional beauty tips.',
    emailPlaceholder: 'Your email address',
    subscribeButton: 'Subscribe',
    subscribing: 'Subscribing...',
    privacyText: 'By signing up you agree to our',
    privacyLink: 'privacy policy',
    privacyEndText: '. You can unsubscribe at any time.',
    successMessage: 'Successfully subscribed!',
    errorTitle: 'Error',
    errorDescription: 'Failed to subscribe. Please try again.',
    alreadySubscribedTitle: 'Already subscribed',
    alreadySubscribedDescription: 'This email address is already on our subscriber list',
    subscribeSuccessTitle: 'Successfully subscribed!',
    subscribeSuccessDescription: 'Thank you for joining our beauty community',
    vipBenefits: 'Membership privileges',
    earlyAccess: 'Early access',
    exclusiveOffers: 'Exclusive offers',
  },
  
  // Home
  home: {
    metaTitle: 'BeauBox - Premium Beauty & Skincare Products',
    metaDescription: 'Discover premium beauty products at BeauBox. Professional skincare, body care, hair care and cosmetics. Delivery throughout Lithuania.',
  },

  // Hero
  hero: {
    titleLine1: 'Discover your',
    titleLine2: 'natural beauty.',
    subtitle: 'Luxurious beauty and skincare products, specially selected to reveal your unique beauty.',
    primaryButton: 'Shop now',
    secondaryButton: 'Learn more',
    imageAlt: 'Beauty products',
    stat1Value: '200+',
    stat1Label: 'Products',
    stat2Value: '2d*',
    stat2Label: 'Delivery',
    stat3Value: '5★',
    stat3Label: 'Reviews',
    floating1Title: 'New',
    floating1Subtitle: 'Striving for perfection',
    floating2Title: '★ Loyalty system',
    floating2Subtitle: 'Earn points and pay less',
  },
  
  // Product Detail
  productDetail: {
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    addToWishlist: 'Add to Wishlist',
    removeFromWishlist: 'Remove from Wishlist',
    share: 'Share',
    inStock: 'In stock',
    outOfStock: 'Out of stock',
    limitedStock: 'Only {count} left in stock',
    sku: 'SKU',
    category: 'Category',
    brand: 'Brand',
    volume: 'Volume',
    skinTypes: 'Suitable for skin types',
    whyChoose: 'Why Choose This Product?',
    qualityGuarantee: 'Quality Guarantee',
    qualityGuaranteeText: 'Original products from trusted manufacturers',
    freeShipping: 'Free Shipping',
    freeShippingText: 'For orders over €50',
    fastDelivery: 'Fast Delivery',
    fastDeliveryText: '1-3 business days throughout Lithuania',
    securePayment: 'Secure Payment',
    securePaymentText: 'Encrypted data protection',
    description: 'Description',
    ingredients: 'Ingredients',
    usage: 'How to Use',
    similarProducts: 'Similar Products',
    customerReviews: 'Customer Reviews',
    noReviews: 'No reviews yet',
    basedOnReviews: 'Based on {count} reviews',
    viewAllProducts: 'View All Products',
    new: 'New',
    bestseller: 'Bestseller',
    sale: 'Sale',
    recommended: 'Recommended',
    files: 'Product Files',
    highQuality: 'High Quality',
    dermatologicallyTested: 'Dermatologically Tested',
    naturalIngredients: 'Natural Ingredients',
    otherShoppersViewed: 'Other shoppers also viewed',
    youMayLike: 'You might also like',
    selectedForYou: 'Products selected based on your preferences and customer reviews',
  },
  
  // Search modal
  searchTitle: "Search",
  searchDescription: "Search products by name, brand, category, description or ingredients",
  searchProducts: "Search products...",
  searching: "Loading...",
  noResultsFound: "No products found matching your search",
  tryDifferentKeywords: "Try different keywords",
  popularSearches: "Popular searches:",
  browseCategories: "Categories:",
  addToCart: "Add to Cart",
  results: "results",
  noCategory: "No category",
  popularSearchTerms: {
    faceSerum: "Face serum",
    moisturizingCream: "Moisturizing cream",
    eyeCream: "Eye cream",
    micellarWater: "Micellar water",
    toner: "Toner",
  },

  // Price display
  priceDisplay: {
    loginToSeePrices: "Log in to see prices",
    login: "Log in",
    priceVisibleAfterConsultation: "Price visible after consultation",
  },

  // Cart context messages
  cartMessages: {
    loginRequired: "Login required",
    loginToAddToCart: "Please log in to add items to cart",
    cartCleared: "Cart cleared",
    allItemsRemoved: "All items removed from cart",
  },

  // Wishlist context messages
  wishlistMessages: {
    loginRequired: "Login required",
    loginToAddToWishlist: "Please log in to add items to wishlist",
    alreadyInWishlist: "Item already in wishlist",
    alreadyInWishlistDesc: "This item is already in your wishlist",
  },

  // SEO meta tags for homepage
  seo: {
    homeTitle: "BeauBox - Moisturizing Cream, Serum, Skincare | Professional Beauty Products in Lithuania",
    homeDescription: "Professional beauty products: moisturizing cream, anti-wrinkle cream, face serum, cleansers, toner, face masks. ⭐ Ekseption, Fusion Mesotherapy, ClinicCare, Naturys, Instinct. Free shipping from €60 🚚",
    homeKeywords: "moisturizing cream, anti-wrinkle cream, face serum, skincare, beauty products, cosmetics, face cream, eye cream, cleansers, face wash, oil cleanser, toner, mask, face mask, ekseption, fusion mesotherapy, cliniccare, naturys, instinct, professional cosmetics, skincare products lithuania",
    ogTitle: "BeauBox - Professional Beauty and Skincare Products in Lithuania",
    ogDescription: "Moisturizing cream, anti-wrinkle cream, face serum and other professional beauty products. Delivery throughout Lithuania.",
    twitterDescription: "Moisturizing cream, serum, anti-wrinkle products. Delivery throughout Lithuania.",
  },

  // Cookie Policy
  cookiePolicy: {
    title: "Cookie Policy",
    description: "This policy explains how cookies are used on our beaubox.lt website",
    lastUpdate: "Last updated:",
    effectiveDate: "Effective:",
    date: "January 2024",
    effectiveDateValue: "January 15, 2024",
    
    whatAreCookies: {
      title: "What are cookies?",
      paragraph1: "Cookies are small text files that websites save on your computer or mobile device when you visit them. Cookies help the website 'remember' your actions and preferences (such as login details, language, font size and other display preferences) for a certain period of time.",
      paragraph2: "Cookies will not harm your computer and cannot transmit viruses. They are safe and widely used on all modern websites to improve user experience."
    },
    
    cookieTypes: {
      title: "What cookies do we use?",
      essential: "Essential cookies",
      functional: "Functional cookies",
      analytical: "Analytical cookies",
      marketing: "Marketing cookies",
      canDisable: "Can be disabled",
      required: "Required",
      purpose: "Purpose:",
      examples: "Examples:",
      retention: "Retention period:",
      legalBasis: "Legal basis:",
      
      essentialPurpose: "Required for website functionality",
      essentialExamples: "Login sessions, cart contents, security settings",
      essentialRetention: "During session or up to 30 days",
      essentialLegal: "Legitimate interest (GDPR Art. 6(1)(f))",
      
      functionalPurpose: "Improves website functionality",
      functionalExamples: "Language settings, region selection, design preferences",
      functionalRetention: "Up to 12 months",
      functionalLegal: "Consent (GDPR Art. 6(1)(a))",
      
      analyticalPurpose: "Helps understand how you use the website",
      analyticalExamples: "Google Analytics, page views, visitor behavior",
      analyticalRetention: "Up to 26 months",
      analyticalLegal: "Consent (GDPR Art. 6(1)(a))",
      
      marketingPurpose: "Used for advertising personalization",
      marketingExamples: "Facebook Pixel, Google Ads, retargeting",
      marketingRetention: "Up to 13 months",
      marketingLegal: "Consent (GDPR Art. 6(1)(a))"
    },
    
    thirdParty: {
      title: "Third-party services",
      description: "We use the following third-party services that may set their own cookies:",
      googleAnalytics: "Google Analytics",
      googleAnalyticsPurpose: "Website statistics collection",
      googleAnalyticsData: "IP address (anonymized), page views, device information",
      facebookPixel: "Facebook Pixel",
      facebookPixelPurpose: "Advertising effectiveness measurement",
      facebookPixelData: "Page views, purchase actions, IP address",
      supabase: "Supabase",
      supabasePurpose: "Database and authentication services",
      supabaseData: "User data, session information",
      dataShared: "Data shared:",
      privacyPolicy: "Privacy Policy →"
    },
    
    management: {
      title: "How to manage cookies?",
      websiteSettings: "Website settings",
      websiteSettingsText: "You can manage your cookie preferences at any time by clicking the 'Cookie Settings' button at the bottom of the website or by contacting us via email.",
      websiteSettingsNote: "Note: disabling essential cookies may cause some website features to not work properly.",
      browserSettings: "Browser settings",
      browserSettingsText: "You can also manage cookies directly in your browser settings:",
      chrome: "Settings → Privacy and security → Cookies",
      firefox: "Settings → Privacy and security → Cookies and site data",
      safari: "Settings → Privacy → Cookie management",
      edge: "Settings → Cookies and site permissions"
    },
    
    gdprRights: {
      title: "Your rights under GDPR",
      rightToInfo: "Right to information",
      rightToInfoText: "You have the right to know what data is collected about you and how it is used.",
      rightToAccess: "Right to access",
      rightToAccessText: "You can request a copy of all personal data processed about you.",
      rightToWithdraw: "Right to withdraw",
      rightToWithdrawText: "You can withdraw your consent for cookie usage at any time.",
      rightToErasure: "Right to erasure",
      rightToErasureText: "You can request deletion of all data collected about you."
    },
    
    contact: {
      title: "Data controller and contacts",
      dataController: "Data controller:",
      companyName: "BeauBox",
      companyCode: "Company code: __________",
      vatCode: "VAT code: LT___________",
      address: "Address:",
      email: "Email: duomenys@beaubox.lt",
      dpoTitle: "Data protection officer:",
      dpoEmail: "Email: info@beaubox.lt",
      dpoPhone: "Phone:",
      complaints: "Complaints:",
      complaintsText: "If you believe your rights have been violated, you can contact:",
      inspectionName: "State Data Protection Inspectorate",
      inspectionContact: "www.ada.lt | ada@ada.lt"
    },
    
    updates: {
      title: "Policy changes",
      paragraph1: "We may update this cookie policy to comply with new legislation, technological changes or our business needs. We will inform you of significant changes via email or by posting a notice on the website.",
      paragraph2: "We recommend reviewing this policy regularly to stay informed about how we protect and use your data."
    }
  },
  
  // Contact
  contact: {
    pageTitle: 'Contact Us',
    subtitle: 'Have questions about products or need help? Our team is always ready to assist you.',
    formTitle: 'Write to us',
    formDesc: 'Fill in the form and we will get back to you within 24 hours',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phoneOptional: 'Phone (optional)',
    subject: 'Subject',
    subjectPlaceholder: 'Question about a product',
    message: 'Message',
    messagePlaceholder: 'Write your question or comment...',
    send: 'Send Message',
    sending: 'Sending...',
    sentTitle: 'Message sent!',
    sentDesc: 'Thank you for your message. We will contact you within 24 hours.',
    errorTitle: 'Error',
    errorDesc: 'Failed to send message. Please try again or contact us by phone.',
    contactInfoTitle: 'Contact Information',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    addressLabel: 'Address',
    workingHours: 'Working Hours',
    monFri: 'Mon–Fri: 9:00 - 18:00',
    sat: 'Sat: 10:00 - 16:00',
    sun: 'Sun: Closed',
    faqTitle: 'FAQ',
    faqDesc: 'Quick answers to frequently asked questions',
    shippingQuestion: 'How much is delivery?',
    returnsQuestion: 'How to return a product?',
    originalQuestion: 'Are the products original?',
    more: 'More',
    consultBannerTitle: 'Consultation request',
    consultBannerDesc: 'The form is pre-filled with your data and product information',
    consultSubject: 'Consultation about products requiring consultation',
    consultHello: 'Hello,',
    consultNoItemsBody: 'I would like to get a consultation about products that require a specialist recommendation.',
    consultWithItemsIntro: 'I would like a consultation about these products in my cart:',
    consultSuffix: 'Please contact me so I can complete the purchase.\n\nThank you!',
  },

  // Delivery Page
  delivery: {
    pageTitle: 'Delivery and Payment',
    pageSubtitle: 'All information about order delivery in Lithuania',
    deliveryMethods: 'Delivery methods',
    standardDelivery: 'Standard delivery',
    standardDeliveryTime: '2-3 business days',
    omnivaLockers: 'Omniva parcel lockers',
    omnivaTime: '1-3 business days',
    freeFrom: 'Free from',
    paymentMethods: 'Payment methods',
    bankCard: 'Bank card (Visa, Mastercard)',
    bankTransfer: 'Bank transfer',
    cashOnDelivery: 'Cash on delivery (courier delivery)',
    securePayment: 'All payments are secure and encrypted with SSL protection',
    yourRights: 'Your rights',
    returnRight: 'Right to return',
    returnRightDesc: '14-day return period according to the Consumer Protection Act',
    warranty: 'Warranty',
    warrantyDesc: '2-year quality warranty for all products',
    complaints: 'Complaints',
    complaintsDesc: 'Free product complaints during the warranty period',
    dataProtection: 'Data protection',
    dataProtectionDesc: 'Your data is stored according to GDPR requirements',
    detailedTerms: 'Detailed delivery terms',
    detailedTermsDesc: 'Complete information about order processing and delivery',
    orderProcessing: 'Order processing',
    orderProcessing1: 'Orders accepted 24/7 online',
    orderProcessing2: 'Orders processed until 17:00 on business days',
    orderProcessing3: 'Weekend and holiday orders processed next business day',
    orderProcessing4: 'Order confirmation sent by email',
    orderProcessing5: 'Delivery information sent by SMS or email',
    deliveryZones: 'Delivery zones',
    allCities: 'All Lithuanian cities:',
    allCitiesTime: '1-3 business days',
    ruralAreas: 'Rural areas:',
    ruralAreasTime: '1-5 business days',
    deliveryAllLithuania: 'We deliver throughout Lithuania',
    importantInfo: 'Important information',
    attention: 'Attention:',
    attentionText: 'Cosmetic products are fragile. Be sure to check package integrity upon delivery.',
    guarantee: 'Guarantee:',
    guaranteeText: 'If the product is damaged during delivery, contact us immediately.',
    contactForDelivery: 'Contact for delivery questions',
    workingHours: 'Mon-Fri: 8:00-17:00',
  },

  // Returns Page
  returns: {
    pageTitle: 'Product Returns and Exchanges',
    pageSubtitle: 'All information about product returns according to the Consumer Rights Protection Act of the Republic of Lithuania',
    days14: '14 days',
    days14Desc: 'Return period from the date of receiving the product',
    fullRefund: 'Full refund',
    fullRefundDesc: 'We refund the full amount within 14 days',
    originalCondition: 'Original condition',
    originalConditionDesc: 'Product must be undamaged and in original packaging',
    returnProcess: 'Return process',
    returnProcessDesc: 'Simple 4-step return process',
    step1Title: 'Contact us',
    step1Desc: 'Send an email or call the phone number provided',
    step2Title: 'Get return code',
    step2Desc: 'We will send you a return number and instructions',
    step3Title: 'Ship the product',
    step3Desc: 'Pack the product and send it to our specified address',
    step4Title: 'Receive refund',
    step4Desc: 'Money will be refunded within 14 days of receiving the product',
    startReturn: 'Start return',
    returnConditions: 'Return conditions',
    returnConditionsDesc: 'When you can return products',
    undamagedProduct: 'Undamaged product',
    undamagedProductDesc: 'Product must be in original condition',
    originalPackaging: 'Original packaging',
    originalPackagingDesc: 'With all labels and packaging elements',
    days14Term: '14 day period',
    days14TermDesc: 'From the date of receiving the product',
    purchaseDocument: 'Purchase document',
    purchaseDocumentDesc: 'Order number or invoice',
    exceptions: 'Exceptions',
    exception1: 'Opened cosmetics (for hygiene reasons)',
    exception2: 'Personalized products',
    exception3: 'Damaged or dirty product',
    exception4: 'Products that may spoil quickly',
    legalInfo: 'Legal information',
    legalInfoDesc: 'According to the Consumer Rights Protection Act of the Republic of Lithuania',
    yourRights: 'Your rights as a consumer',
    right1: '14-day return right - you can return the product without stating a reason',
    right2: 'Money refund within 14 days of receiving the returned product',
    right3: 'Product exchange for a different size, color or model',
    right4: 'Free return if the product is of poor quality or damaged',
    right5: 'Warranty repair or replacement for 2 years',
    ourCommitments: 'Our commitments',
    commitment1: 'Quick response - we respond within 24 hours',
    commitment2: 'We exchange products free of charge if there is a manufacturer defect',
    commitment3: 'We provide consultations on product use',
    importantProvisions: 'Important provisions',
    provision1: 'The right of return is valid for 14 calendar days from receipt of the product',
    provision2: 'Return costs are borne by the buyer, except in cases where the product is of poor quality',
    provision3: 'Money is refunded in the same way it was paid',
    provision4: 'Cosmetic products are returned only if there is a quality defect',
    provision5: 'For disputes, contact the State Consumer Rights Protection Service',
    contactTitle: 'Contact for return questions',
    contactDesc: 'Contact us in any convenient way',
    returnEmail: 'Email for returns',
    phone: 'Phone',
    workingHours: 'Working hours',
    workingHoursTime: 'Mon-Fri: 9:00-17:00',
    returnAddress: 'Return address',
    addressWarning: 'Before sending the product, be sure to contact us and get a return code!',
    important: 'Important:',
    gmailOpened: 'Gmail opened in new window',
    gmailDesc: 'Fill out the request and send us a return inquiry.',
    emailSubject: 'Product return request',
    emailBody: 'Hello,\n\nI would like to start the product return process.\n\nOrder number: [Your order number]\nProduct name: [Product name]\nReason for return: [Your reason]\n\nPlease send me a return code and instructions.\n\nThank you!',
  },

  // FAQ Page
  faq: {
    title: 'Frequently Asked Questions',
    description: 'Find answers to the most common questions about our products, delivery, payment and returns. Can\'t find an answer? Contact us!',
    contactTitle: 'Can\'t find the answer to your question?',
    contactDescription: 'Our customer service team is happy to help. Contact us in any convenient way.',
    email: 'Email',
    emailSubtitle: 'Response within 24 hours',
    phone: 'Phone',
    phoneSubtitle: 'Mon-Fri 9:00-18:00',
    directHelp: 'Direct Help',
    directHelpSubtitle: 'Quick response',
    contactPage: 'Contact page',
    categories: {
      orders: 'Orders and Delivery',
      products: 'Products and Quality',
      payment: 'Payment and Invoices',
      returns: 'Returns and Exchanges',
      account: 'Account and Loyalty',
    },
    questions: {
      deliveryTime: 'How long does delivery take?',
      deliveryTimeAnswer: 'Standard delivery takes 1-3 business days in Lithuania. Express orders can be delivered within 24 hours for an additional fee.',
      freeShipping: 'What is the minimum order size for free delivery?',
      freeShippingAnswer: 'Free delivery applies to orders from {threshold} €. For smaller orders, a {cost} € delivery fee applies.',
      changeOrder: 'Can I change or cancel my order?',
      changeOrderAnswer: 'You can change or cancel your order within 1 hour of placing it, if it has not yet been prepared for shipping. Contact us by phone or email.',
      deliveryMethods: 'What delivery methods are available?',
      deliveryMethodsAnswer: 'We deliver to Omniva parcel machines, by mail, and via courier services directly to your home or office.',
      originalProducts: 'Are all products original?',
      originalProductsAnswer: 'Yes, we sell only original products, purchased directly from official manufacturer representatives or manufacturers themselves.',
      skinType: 'How do I know which product suits my skin type?',
      skinTypeAnswer: 'The appropriate skin type is indicated in each product description. You can also contact our consultants.',
      samples: 'Can I get a product sample before buying?',
      samplesAnswer: 'Yes, we have samples for some products. They are added to your order for free or you can order them separately on our website.',
      expiry: 'What is the expiry date of products?',
      expiryAnswer: 'All products are sold with at least 6 months of expiry time. The exact expiry date is indicated on each product package.',
      paymentMethods: 'What payment methods are accepted?',
      paymentMethodsAnswer: 'We accept payments by bank cards (Visa, Mastercard), internet banking transfers, Paysera and cash on delivery.',
      installments: 'Can I pay in installments?',
      installmentsAnswer: 'No',
      paymentTiming: 'When is the money deducted for the order?',
      paymentTimingAnswer: 'When paying by card, money is deducted immediately after order confirmation. When paying by bank transfer - when we receive payment.',
      invoice: 'Can I get an invoice?',
      invoiceAnswer: 'Yes, we issue invoices to registered companies. Specify company details when ordering.',
      returnPeriod: 'How long can I return a product?',
      returnPeriodAnswer: 'You can return products within 14 calendar days of receipt if they are unused and in original packaging.',
      nonReturnable: 'What products cannot be returned?',
      nonReturnableAnswer: 'For hygiene reasons, we cannot accept returns of opened or used products, especially lipsticks, masks and eye makeup products.',
      returnCosts: 'Who pays for return costs?',
      returnCostsAnswer: 'If the product is returned due to our fault (incorrect data, defect), we pay return costs. In other cases - the buyer.',
      returnProcess: 'How to return a product?',
      returnProcessAnswer: 'Contact us by email or phone, specify the order number and reason for return. We will send return instructions.',
      benefits: 'What benefits do registered users have?',
      benefitsAnswer: 'Registered users get special offers, accumulate loyalty points, can track order history and fill orders faster.',
      loyaltyProgram: 'How does the loyalty program work?',
      loyaltyProgramAnswer: 'For every euro spent, you earn 0.01 loyalty points. 1 point = 1 € discount on the next order.',
      editAccount: 'Can I change my account details?',
      editAccountAnswer: 'Yes, after logging into your account you can edit personal details, delivery addresses and payment information.',
      resetPassword: 'How to reset a forgotten password?',
      resetPasswordAnswer: 'On the login page, click "Forgot password" and enter your email address. We will send you a password reset link.',
    },
  },

  // Cart
  cart: {
    title: 'Your Cart',
    items: 'items',
    item: 'item',
    empty: 'Your cart is empty',
    emptyDescription: 'Start shopping and discover great products',
    continueShopping: 'Continue Shopping',
    preparingOrder: 'Preparing order...',
    loading: 'Loading...',
    freeDelivery: 'Free delivery',
    delivery: 'Delivery',
    securePayment: 'Secure payment',
    qualityGuarantee: 'Quality guarantee',
    consultationRequired: 'Consultation required',
    consultationProvided: 'Consultation provided',
    each: 'each',
    consultationWarningTitle: 'Cart contains items that require consultation',
    consultationWarningDesc: 'Payment will not be available. Contact us for consultation on these items.',
    itemsValue: 'Items value:',
    deliveryLabel: 'Delivery:',
    free: 'Free',
    total: 'Total to pay:',
    paymentUnavailable: 'Payment unavailable',
    buyNow: 'Buy Now',
    contactForConsultation: 'Contact for Consultation',
    updateCart: 'Update Cart',
    clearCart: 'Clear Cart',
    sslProtection: '256-bit SSL protection • Secure payment',
    addedToCart: 'Added to cart',
    productAddedToCart: 'added to cart',
    viewCart: 'View cart',
  },

  // About
  about: {
    heading: "About BeauBox",
    intro: "– is not just a beauty products store, it is a true beauty world where exclusive brands meet.",
    mission: "Our mission is to help every woman discover her unique beauty ritual. We not only sell products, but also create stories, teach, inspire and accompany you on your beauty journey.",
    quality: "Each product we offer is carefully selected, tested and approved by our team of specialists. We believe that beauty starts with healthy skin and the right choice of products.",
    features: {
      premiumQuality: {
        title: "Premium Quality",
        description: "Only the highest quality products from trusted suppliers are selected"
      },
      expertAdvice: {
        title: "Expert Advice",
        description: "Each product is recommended by certified cosmetologists"
      },
      naturalIngredients: {
        title: "Natural Ingredients",
        description: "Priority is given to natural and organic products"
      },
      individualProgram: {
        title: "Individual Program",
        description: "We create a unique beauty complex for every skin type"
      }
    }
  },

  // Products
  products: {
    title: 'Our Products',
    description: 'Discover your beauty with our carefully selected products, designed for every skin type and need.',
    filters: 'Product Filters',
    clearFilters: 'Clear Filters',
    category: 'Category',
    selectCategory: 'Select Category',
    skinType: 'Skin Type',
    selectSkinType: 'Select Skin Type',
    brand: 'Brand',
    allBrands: 'All Brands',
    allPurposes: 'All',
    purpose: 'Purpose',
    all: 'All',
    priceRange: 'Price Range',
    activeFilters: 'Active Filters:',
    removeFilter: 'Remove Filter',
    found: 'Found',
    productsCount: 'products',
    allProducts: 'All Products',
    allSkinTypes: 'All Skin Types',
    badges: {
      new: 'New',
      popular: 'Popular',
      recommended: '★ Recommended by Cosmetologists',
      consultationRequired: 'Consultation Required',
      bestseller: '🔥 Bestseller',
      recommendedShort: '★ Recommended',
    },
    buttons: {
      addToWishlist: 'Add to Wishlist',
      quickView: 'Quick View',
      addToCart: 'Add to Cart',
      buy: 'Buy',
      contactForConsultation: 'Contact for Consultation',
    },
    reviewsCount: 'reviews',
    stockUrgency: 'Only {count} left!',
    saveAmount: 'Save €{amount}',
    loginToSeePrice: 'Login to see price',
    viewAllProducts: 'View All Products',
  },

  // Wishlist
  wishlist: {
    title: 'Wishlist',
    items: 'items',
    item: 'item',
    empty: 'Your wishlist is empty',
    emptyDescription: 'Add products you like and come back to them later',
    discoverProducts: 'Discover products',
    featuredTitle: 'Your most interesting products',
    featuredDescription: 'Get them now and enjoy special offers',
    addToCart: 'Add to cart',
    view: 'View',
    totalProducts: 'Total products:',
    addAllToCart: 'Add all to cart',
    continueShopping: 'Continue shopping',
    savedToProfile: 'Saved to your profile',
  },

  // Checkout
  checkout: {
    title: 'Order Information',
    userInfo: 'User Information',
    companyInfo: 'Company Information',
    deliveryInfo: 'Delivery Information',
    paymentMethod: 'Payment Method',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    companyCode: 'Company Code',
    companyVatCode: 'VAT Code',
    optional: 'optional',
    fillIfCompany: 'Fill in if purchasing for a company',
    deliveryMethod: 'Delivery Method',
    homeDelivery: 'Home Delivery',
    homeDeliveryDesc: 'Courier delivery to specified address',
    parcelMachine: 'Omniva Parcel Machine',
    parcelMachineDesc: 'Pickup from selected parcel machine',
    salonPickup: 'Salon Pickup',
    salonPickupDesc: 'Free pickup from selected location',
    address: 'Address',
    addressPlaceholder: 'Street name and house number',
    city: 'City',
    cityPlaceholder: 'City',
    postalCode: 'Postal Code',
    postalCodePlaceholder: '12345',
    selectParcelMachine: 'Select Parcel Machine',
    selectParcelMachineError: 'Please select a parcel machine for delivery',
    selectSalon: 'Select Pickup Location',
    selectSalonError: 'Please select a salon for pickup',
    paymentMethodTitle: 'Payment Method',
    paymentMethodDesc: 'Choose a convenient payment method',
    cardPayment: 'Bank Card',
    cardPaymentDesc: 'Fast and secure payment',
    popular: 'Most Popular',
    instantPayment: 'Instant payment',
    pciSecurity: 'PCI DSS security',
    payseraPayment: 'Paysera Bank Transfer',
    payseraPaymentDesc: 'Payment via online banking',
    securePayment: 'Secure payment',
    allBanks: 'All banks',
    cashOnDelivery: 'Cash on Delivery',
    cashOnDeliveryDesc: 'Pay upon delivery',
    additionalFee: 'Additional fee',
    cashOnly: 'Cash only',
    bankTransfer: 'Bank Transfer',
    bankTransferDesc: 'Transfer from your bank',
    processing: '1-2 business days processing',
    additionalInstructions: 'No additional fees',
    cardholderDetails: 'Cardholder Details',
    cardholderName: 'First Name',
    cardholderLastName: 'Last Name',
    orderSummary: 'Order Summary',
    itemsValue: 'Items Value',
    discount: 'Discount',
    loyaltyDiscount: 'Loyalty Discount',
    shipping: 'Shipping',
    free: 'Free',
    total: 'Total',
    placeOrder: 'Place Order',
    processingButton: 'Processing...',
    secureCheckout: '256-bit SSL protection • Secure payment',
    loginRequired: 'Login Required',
    loginRequiredDesc: 'You need to login or create an account to place an order.',
    loginRegister: 'Login / Register',
    backToStore: 'Back to Store',
    processingOrder: 'Processing Order...',
    processingOrderDesc: 'Please wait, we are preparing your order',
    orderReceived: 'Order Received!',
    orderReceivedDesc: 'Thank you for your order. You will receive a confirmation email shortly.',
    orderNumber: 'Order Number:',
    emptyCart: 'Cart is Empty',
    emptyCartDesc: 'Add products to cart before purchasing.',
    shop: 'Shop',
    paymentBlocked: 'Payment Unavailable',
    paymentBlockedDesc: 'Your cart contains items that require consultation before purchase. Payment is blocked for security reasons. Please contact us for consultation.',
    contactForConsultation: 'Contact for Consultation',
    loyaltyPoints: 'Loyalty Points',
    availablePoints: 'Your available points:',
    usePoints: 'Use Points',
    pointsToUse: 'Points to use:',
    useAllPoints: 'Use All Points',
    pointsValue: '1 point = 1€ discount',
    youWillEarn: 'You will earn from this order:',
    points: 'points',
    earnedAfterDiscount: '(calculated after discount)',
    minimumCharge: 'Minimum charge: 0.01€ per unit',
    consultationRequired: 'Consultation Required',
    consultationApproved: 'Consultation Approved',
    consultationRequiredTitle: 'Consultation Required',
    consultationRequiredDesc: 'Your cart contains items that require consultation. Please contact us.',
    missingInfo: 'Missing Information',
    missingAddressDesc: 'Please fill in all delivery address fields',
    loadingSettings: 'Loading...',
    loadingSettingsDesc: 'Please wait while shipping settings are loaded',
    paymentUnavailable: 'Payment System Unavailable',
    paymentUnavailableDesc: 'Payment system is temporarily unavailable. Please try again later or contact us.',
    paymentError: 'Error',
    paymentErrorDesc: 'Failed to create payment. Please try again.',
    noPaymentUrl: 'Failed to get payment link. Please try again.',
    popupBlocked: 'Popup Blocked',
    popupBlockedDesc: 'Please allow popups for this site and try again.',
    paymentSessionCreated: 'Payment Session Created',
    paymentSessionDesc: 'Payment window opened. Complete payment in the new window.',
    paymentSystemNotLoaded: 'Payment system not yet loaded. Please try again.',
    cardFieldNotFound: 'Card details field not found.',
    paymentConfirmError: 'Payment Error',
    paymentConfirmErrorDesc: 'Payment failed. Please check your card details.',
    paymentSuccess: 'Payment Successful!',
    paymentSuccessDesc: 'Your order has been successfully paid and created.',
    backendError: 'Payment succeeded but an error occurred processing the order. Please contact us.',
    orderCreated: 'Order Created',
    orderCreatedDesc: 'Your order has been successfully submitted',
    parcelReserved: 'Parcel Machine Reserved',
    parcelReservedDesc: 'Parcel machine successfully reserved. Tracking number:',
    orderError: 'Failed to submit order. Please try again.',
    orderSuccessTitle: 'Order Successfully Created!',
    orderSuccessDesc: 'Your order number:',
    
    // Additional translations for checkout page
    companyInfoOptional: "Optional - fill in if purchasing for a company",
    parcelMachineRequired: "Please select a parcel machine for delivery",
    salonRequired: "Please select a salon for pickup",
    selectPaymentMethod: "Choose convenient payment method",
    bankCard: "Bank Card",
    bankCardDesc: "Fast and secure payment",
    mostPopular: "Most Popular",
    payseraBankTransfer: "Paysera Bank Transfer",
    payseraDesc: "Payment via online banking",
    noAdditionalFees: "No additional fees",
    cardDetails: "Card Details",
    cardFirstName: "First Name",
    cardLastName: "Last Name",
    paymentSecurityInfo: "Payment data is processed securely according to PCI DSS standards",
    loyaltyPointsTitle: "Loyalty Points",
    loyaltyPointsAvailable: "You have {points} points. 1 point = €1 discount",
    useLoyaltyPoints: "Use loyalty points",
    pointsAmount: "Points amount (max. {max})",
    youWillSave: "✓ You will save: €{amount}",
    quantity: "Quantity: {count}",
    priceAfterConsultation: "Price visible after consultation",
    perUnit: "per unit",
    consultationRequiredBadge: "Consultation required",
    consultationProvidedBadge: "Consultation provided",
    products: "Products:",
    loyaltyPointsDiscount: "Loyalty points discount (-{points} pts.):",
    loyaltyPointsEarn: "🏆 Loyalty Points",
    earnPoints: "You will earn: +{points} points",
    addForFreeShipping: "Add €{amount} worth of products to get free shipping",
    orderSubmitted: "Order Submitted",
    submitOrder: "Submit Order"
  },

  // Quick Checkout
  quickCheckout: {
    title: 'Quick Purchase',
    description: 'Complete your order with one click using your saved card',
    buyNow: 'Buy Now',
    cancel: 'Cancel',
    deliveryMethod: 'Delivery Method',
    paymentMethod: 'Payment Method',
    savedCard: 'Saved Card',
    newCard: 'New Card',
    selectPaymentMethod: 'Select payment method',
    itemPrice: 'Item Price',
    shippingCost: 'Shipping',
    totalPrice: 'Total',
    processing: 'Processing...',
    loginRequired: 'Please Login',
    loginRequiredDesc: 'You need to login to use quick purchase',
    selectDeliveryMethod: 'Select delivery method',
    selectParcelMachine: 'Select parcel machine',
    selectSalon: 'Select salon',
    enterCardDetails: 'Enter card details',
    paymentSuccess: 'Payment Successful!',
    paymentSuccessDesc: 'Your order has been successfully created',
    paymentError: 'Payment Error',
    paymentErrorDesc: 'Failed to process payment. Please try again.',
    orderCreated: 'Order Created!',
    homeDelivery: 'Home Delivery',
    parcelMachineDelivery: 'Parcel Machine Delivery',
    salonPickup: 'Salon Pickup',
    free: 'Free',
    cardDetails: 'Card Details',
    productLabel: 'Product:',
    shippingLabel: 'Shipping:',
    totalLabel: 'Total:',
    buyFor: 'Buy for',
    purchaseType: 'Purchase Type',
    oneTimePurchase: 'One-time Purchase',
    subscribeProduct: 'Subscribe & Save',
    recurringPeriod: 'Billing Period',
    monthly: 'Monthly',
    yearly: 'Yearly',
    save10: 'Save 10%',
    subscriptionPrice: 'Subscription Price',
    savings: 'Savings',
    subscribeNow: 'Subscribe Now',
    redirecting: 'Redirecting to payment page...',
    errors: {
      selectParcelMachine: 'Select Parcel Machine',
      selectParcelMachineDesc: 'Please select a delivery parcel machine',
      selectSalon: 'Select Salon',
      selectSalonDesc: 'Please select a pickup salon',
      error: 'Error',
      paymentSystemNotLoaded: 'Payment system not yet loaded',
      cardElementNotFound: 'Card details field not found',
      clientSecretMissing: 'Client secret not received from payment system',
    },
  },

  // Omniva Parcel Machine Selector
  omniva: {
    label: 'Omniva parcel machine',
    change: 'Change',
    selectTitle: 'Select parcel machine',
    searchPlaceholder: 'Search by name, city or address...',
    loading: 'Loading parcel machines...',
    notFound: 'No parcel machines found',
    emptyList: 'Parcel machine list is empty',
    selectButton: 'Select parcel machine',
    selectDescription: 'Click to select a delivery parcel machine',
    error: 'Error',
    loadError: 'Failed to load parcel machine list',
  },

  // Account Page
  account: {
    backToShop: 'Back to shop',
    loyaltyPoints: 'loyalty points',
    user: 'User',
    
    // Tabs
    orders: 'Orders',
    invoices: 'Invoices',
    profile: 'Profile',
    addresses: 'Addresses',
    settings: 'Settings',
    
    // Invoices Section
    invoicesTitle: 'Invoices',
    invoicesCount: 'invoices',
    invoicesCountSingle: 'invoice',
    loadingInvoices: 'Loading invoices...',
    noInvoices: 'No invoices',
    noInvoicesDescription: 'No invoices have been issued to you yet.',
    loadInvoicesError: 'Failed to load invoices',
    issueDate: 'Issued',
    paymentTerm: 'Payment term',
    paymentTerms: 'Payment terms',
    overdue: 'Overdue',
    downloadPdf: 'Download PDF',
    sendEmail: 'Send via email',
    preparing: 'Preparing...',
    sending: 'Sending...',
    downloadSuccess: 'Downloaded successfully',
    downloadSuccessDesc: 'PDF invoice {invoiceNumber} downloaded',
    downloadError: 'Failed to download invoice',
    emailSent: 'Email sent',
    emailSentDesc: 'Invoice {invoiceNumber} sent to {email}',
    emailSendError: 'Failed to send email',
    invoiceStatus: {
      draft: 'Draft',
      sent: 'Sent',
      paid: 'Paid',
      cancelled: 'Cancelled',
    },
    
    // Orders Section
    myOrders: 'My orders',
    ordersDescription: 'View your order history and status',
    loadingOrders: 'Loading orders...',
    noOrders: 'You have no orders yet',
    startShopping: 'Start shopping',
    order: 'Order',
    products: 'products',
    product: 'product',
    details: 'Details',
    
    // Order Statuses
    status: {
      pending: 'Pending',
      confirmed: 'Confirmed',
      processing: 'Processing',
      shipped: 'Shipped',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
    },
    
    // Order Details Dialog
    orderDetails: 'Order details',
    orderInformation: 'Order information',
    orderNumber: 'Order number',
    number: 'Number',
    date: 'Date',
    time: 'Time',
    orderDate: 'Order date',
    orderStatus: 'Order status',
    totalAmount: 'Total amount',
    shippingCost: 'Shipping cost',
    loyaltyPointsUsed: 'Loyalty points used',
    paymentStatus: 'Payment status',
    paid: 'Paid',
    pending: 'Pending',
    productQuantity: 'Product quantity',
    totalWeight: 'Total weight',
    orderProgress: 'Order status',
    deliveryMethod: 'Delivery method',
    deliveryAddress: 'Delivery address',
    deliveryInformation: 'Delivery information',
    deliveryAddressNotSpecified: 'Delivery address not specified',
    recipient: 'Recipient',
    company: 'Company',
    notSpecified: 'Not specified',
    paymentMethod: 'Payment method',
    orderItems: 'Order items',
    quantity: 'Quantity',
    unitPrice: 'Unit price',
    discount: 'Discount',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    total: 'Total',
    orderedOn: 'Ordered on',
    selectedSalon: 'Selected salon',
    omnivaParcelMachine: 'Omniva parcel machine',
    deliveryLocation: 'Delivery location',
    orderedProducts: 'Ordered products',
    orderSummary: 'Order summary',
    loyaltyPointsUsedLabel: 'Loyalty points used',
    freeShipping: 'Free',
    likedOrder: 'Liked the order?',
    browseProducts: 'Browse our latest beauty products',
    continueShopping: 'Continue shopping',
    
    // Delivery Methods
    delivery: {
      salonPickup: 'Salon pickup',
      salonPickupDesc: 'Products will be ready for pickup at salon',
      omnivaPickup: 'Omniva parcel locker',
      omnivaPickupDesc: 'Delivery to selected Omniva locker',
      standardDelivery: 'Standard delivery',
      standardDeliveryDesc: 'Courier delivery to specified address',
      expressDelivery: 'Express delivery',
      expressDeliveryDesc: 'Delivery within 1-2 business days',
      homeDelivery: 'Delivery to specified address',
    },
    
    // Payment Methods
    payment: {
      card: 'Bank card',
      cardDesc: 'Payment by bank card',
      cash: 'Cash',
      cashDesc: 'Cash payment on delivery',
      bankTransfer: 'Bank transfer',
      bankTransferDesc: 'Payment by bank transfer',
      mobilePayment: 'Mobile payment',
      mobilePaymentDesc: 'Payment via mobile phone',
      paysera: 'Paysera',
      payseraDesc: 'Payment via Paysera system',
    },
    
    // Profile Section
    myProfile: 'My profile',
    profileInformation: 'Profile Information',
    profileDescription: 'Manage your personal information',
    updateYourPersonalInformation: 'Update your personal information',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    companyInformationOptional: 'Company Information (optional)',
    companyCode: 'Company code',
    companyVatCode: 'VAT code',
    optional: 'Optional',
    saveChanges: 'Save changes',
    
    // Addresses Section
    shippingAddresses: 'Shipping addresses',
    addressesDescription: 'Manage your delivery addresses',
    street: 'Street',
    streetAndNumber: 'Street and house number',
    city: 'City',
    postalCode: 'Postal code',
    saveAddress: 'Save address',
    
    // Settings Section
    accountSettings: 'Account settings',
    settingsDescription: 'Manage your account settings and security',
    passwordChange: 'Password change',
    emailPreferences: 'Email subscriptions',
    newsletter: 'Receive newsletters',
    newsletterDesc: 'Receive latest news and offers',
    specialOffers: 'Receive special offers',
    specialOffersDesc: 'Receive information about promotions and discounts',
    productRecommendations: 'Receive product recommendations',
    productRecommendationsDesc: 'Receive personalized product suggestions',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Repeat new password',
    updatePassword: 'Change password',
    savePreferences: 'Save subscription settings',
    logout: 'Sign out',
    logoutFromAccount: 'Sign out from account',
    
    // Toast Messages
    toast: {
      error: 'Error',
      success: 'Successfully saved',
      loadError: 'Failed to load orders',
      emailUpdateError: 'Failed to update email address',
      profileUpdateError: 'Failed to save profile',
      profileUpdated: 'Profile information updated',
      addressUpdateError: 'Failed to save address',
      addressUpdated: 'Address successfully updated',
      preferencesUpdateError: 'Failed to save settings',
      preferencesUpdated: 'Subscription settings updated',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      passwordUpdateError: 'Failed to change password',
      passwordUpdated: 'Password successfully updated',
      loggedOut: 'Logged out',
      loggedOutDesc: 'Successfully logged out from account',
    },
  },
  
  
  // Authentication
  auth: {
    title: 'BeauBox',
    subtitle: 'Login to your account',
    loginTab: 'Login',
    signupTab: 'Register',
    loginTitle: 'Login',
    loginDescription: 'Enter your details to login',
    signupTitle: 'Registration',
    signupDescription: 'Create a new account',
    email: 'Email',
    emailPlaceholder: 'name@example.com',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    createPasswordPlaceholder: 'Create a password',
    confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: 'Repeat password',
    firstName: 'First name',
    firstNamePlaceholder: 'First name',
    lastName: 'Last name',
    lastNamePlaceholder: 'Last name',
    forgotPassword: 'Forgot password?',
    loginButton: 'Login',
    signupButton: 'Register',
    loggingIn: 'Logging in...',
    signingUp: 'Registering...',
    googleLogin: 'Login with Google',
    facebookLogin: 'Login with Facebook',
    or: 'Or',
    loginSuccess: 'Successfully logged in!',
    loginSuccessDesc: 'Welcome back to BeauBox',
    loginError: 'Login error',
    signupSuccess: 'Successfully registered!',
    signupSuccessDesc: 'Welcome to BeauBox',
    signupError: 'Registration error',
    passwordMismatch: 'Passwords do not match',
    passwordMismatchDesc: 'Check that both passwords are the same',
    googleLoginSuccess: 'Successfully logged in with Google!',
    googleLoginError: 'Google login error',
    facebookLoginSuccess: 'Successfully logged in with Facebook!',
    facebookLoginError: 'Facebook login error',
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
  },
  
  termsOfUse: {
    title: 'Terms of Use',
    subtitle: 'BeauBox.lt online store terms and conditions',
    lastUpdated: 'Last updated',
    effectiveDate: 'Effective date',
    
    section1: {
      title: '1. General Provisions',
      intro: 'These Terms of Use (hereinafter referred to as "Terms") govern the use of the beaubox.lt online store.',
      agreement: 'By using this website, you agree to these terms and undertake to comply with them. If you do not agree with these terms, you may not use our services.',
      sellerData: 'Seller information:',
      companyCode: 'Company code',
      vatCode: 'VAT code',
      address: 'Address',
      email: 'Email',
      phone: 'Phone',
    },
    
    section2: {
      title: '2. Services Provided',
      intro: 'The following services are provided on the BeauBox.lt website:',
      service1: 'Online sale of beauty and cosmetic products',
      service2: 'Beauty consultations',
      service3: 'Product delivery to specified address',
      service4: 'Provision of distance trading services',
      service5: 'Customer service',
      legal: 'Services are provided in accordance with the laws of the Republic of Lithuania, especially the provisions of the Civil Code, the Consumer Protection Law, and the Electronic Commerce Law.',
    },
    
    section3: {
      title: '3. Registration and Account',
      registrationRequirements: '3.1 Registration Requirements',
      requirement1: 'Persons aged 16 and over can register (minors need parental/guardian consent)',
      requirement2: 'Accurate and correct information must be provided',
      requirement3: 'Email address must be valid and accessible',
      requirement4: 'Password must be secure (minimum 8 characters)',
      accountUsage: '3.2 Account Usage',
      usage1: 'You are responsible for the security of your account',
      usage2: 'Do not allow third parties to use your account',
      usage3: 'Report unauthorized access immediately',
      usage4: 'You can delete your account at any time',
    },
    
    section4: {
      title: '4. Orders and Payments',
      orderProcessing: '4.1 Order Processing',
      processing1: 'An order is considered confirmed after payment is received',
      processing2: 'We reserve the right to cancel an order if the item is out of stock',
      processing3: 'We inform you about order status changes by email',
      processing4: 'Order data is stored for 10 years for accounting purposes',
      paymentMethods: '4.2 Payment Methods',
      methodsIntro: 'Accepted payment methods:',
      method1: 'Bank transfer',
      method2: 'Bank cards (Visa, Mastercard)',
      method3: 'Electronic payment systems (Stripe)',
      method4: 'Cash on delivery (only in Lithuania)',
      pricesAndTaxes: '4.3 Prices and Taxes',
      price1: 'All prices include VAT',
      price2: 'Shipping cost is calculated separately',
      price3: 'We reserve the right to change prices without prior notice',
      price4: 'The price at the time of order confirmation applies',
    },
    
    section5: {
      title: '5. Delivery',
      deliveryTermsTitle: 'Delivery times:',
      term1: 'Lithuania: 1-3 business days',
      term2: 'EU countries: 3-7 business days',
      term3: 'Other countries: by separate agreement',
      deliveryMethodsTitle: 'Delivery methods:',
      method1: 'Courier service to home/office',
      method2: 'Parcel machines (Omniva)',
      method3: 'Post offices',
      method4: 'Pickup from warehouse (by agreement)',
      riskTransfer: 'Delivery risk passes to the buyer when the goods are handed over to the courier service or other delivery method.',
    },
    
    section6: {
      title: '6. Returns and Warranties',
      distanceSalesTitle: '6.1 Termination of Distance Sales Contract',
      distanceSalesIntro: 'In accordance with the Consumer Protection Law, you have the right to:',
      right1: 'Terminate the contract within 14 calendar days from receipt of the goods',
      right2: 'Return the item in original condition (unused, undamaged)',
      right3: 'Exceptions: cosmetic products that have been opened or used',
      right4: 'Return costs are borne by the buyer',
      qualityWarrantyTitle: '6.2 Product Quality Warranty',
      warranty1: 'We provide a 2-year quality warranty',
      warranty2: 'Warranty is valid from the date of delivery',
      warranty3: 'Warranty does not apply in case of improper use',
      warranty4: 'In case of defects, we repair, replace or refund the product',
    },
    
    section7: {
      title: '7. Intellectual Property Rights',
      intro: 'All website content (texts, photos, logos, design) belongs to UAB "Gražuolė" or third parties and is protected by intellectual property rights.',
      prohibitedTitle: 'Prohibited:',
      prohibited1: 'Copy website content for commercial purposes',
      prohibited2: 'Use our trademarks without permission',
      prohibited3: 'Modify or distribute the website code',
      prohibited4: 'Create website copies or reverse engineering solutions',
    },
    
    section8: {
      title: '8. Prohibited Activities',
      intro: 'By using our services, you agree to:',
      doNotBreakLaws: 'Not break the law and:',
      prohibition1: 'Not violate the rights of others',
      prohibition2: 'Not send spam or malicious messages',
      prohibition3: 'Not attempt to compromise website security',
      prohibition4: 'Not use automated systems to collect data',
      prohibition5: 'Not spread false information',
      prohibition6: 'Not post reviews about products not purchased',
    },
    
    section9: {
      title: '9. Liability',
      ourLiabilityTitle: '9.1 Our Liability',
      our1: 'We are responsible for product quality according to applicable laws',
      our2: 'We are not responsible for website malfunctions due to technical reasons',
      our3: 'We are not responsible for losses arising from improper use of products',
      our4: 'Maximum liability does not exceed the order value',
      yourLiabilityTitle: '9.2 Your Liability',
      your1: 'You are responsible for the accuracy of information provided',
      your2: 'You are responsible for account security',
      your3: 'You must comply with these terms of use',
      your4: 'You are responsible for damages caused by violation of terms',
    },
    
    section10: {
      title: '10. Dispute Resolution',
      consumerDisputesTitle: 'Consumer Disputes',
      consumerDisputesIntro: 'Consumer disputes are resolved through:',
      resolution1: 'Negotiations with BeauBox.lt representatives',
      resolution2: 'State Consumer Rights Protection Service',
      resolution3: 'Consumer Dispute Commissions',
      resolution4: 'Courts of the Republic of Lithuania',
      consumerProtectionTitle: 'Consumer Rights Protection Service:',
      consumerProtectionAddress: 'Vilniaus g. 25, 01402 Vilnius',
      consumerProtectionPhone: 'Tel. 8 5 262 6751',
      consumerProtectionEmail: 'Email: info@vtat.lt',
      businessDisputesTitle: 'Business Customer Disputes',
      businessDisputes: 'Disputes with business customers are resolved in the courts of the Republic of Lithuania in accordance with the substantive and procedural law of the Republic of Lithuania.',
    },
    
    section11: {
      title: '11. Changes to Terms and Contact',
      termsChangesTitle: 'Changes to Terms',
      termsChanges: 'We reserve the right to change these terms. We will inform registered users about significant changes by email no later than 30 days before the changes take effect.',
      contactTitle: 'Contact',
      emailLabel: 'Email:',
      phoneLabel: 'Phone:',
      workingHoursLabel: 'Working hours:',
      workingHours: 'Mon-Fri 9:00-18:00',
      addressLabel: 'Address:',
    },
    
    footer: {
      relatedLinks: 'Related Links:',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      delivery: 'Delivery',
      returns: 'Returns',
    },
  },

  // Privacy Policy page
  privacyPolicy: {
    hero: {
      title: "Privacy Policy",
      subtitle: "BeauBox.lt privacy policy in accordance with the General Data Protection Regulation (GDPR)",
      lastUpdate: "Last updated:",
      effectiveDate: "Effective:",
      updateDate: "January 2024",
      effectiveValue: "January 15, 2024"
    },
    dataController: {
      title: "Data Controller",
      companyInfo: "Company Information:",
      companyName: "MB \"Beaubox\"",
      companyCode: "Company code:",
      vatCode: "VAT code:",
      address: "Address:",
      email: "Email:",
      phone: "Phone:",
      dpoInfo: "Data Protection Officer:",
      dpoEmail: "Email: info@beaubox.lt",
      dpoPhone: "Phone:",
      dpoAddress: "Postal address:"
    },
    dataProcessing: {
      title: "What data we collect and why",
      account: {
        title: "Account data",
        data: "Data:",
        dataValue: "First name, last name, email address, password (encrypted), phone number",
        purpose: "Purpose:",
        purposeValue: "Account creation, login, order management, customer service",
        legalBasis: "Legal basis:",
        legalBasisValue: "Contract (GDPR Article 6(1)(b))",
        retention: "Retention period:",
        retentionValue: "While account is active + 3 weeks after deletion request"
      },
      orders: {
        title: "Order data",
        dataValue: "Delivery address, billing information, ordered items information, payment data",
        purposeValue: "Order fulfillment, delivery, accounting, warranty administration",
        legalBasisValue: "Contract (GDPR Article 6(1)(b)), legal requirement (accounting)",
        retentionValue: "10 years (accounting requirements)"
      },
      marketing: {
        title: "Marketing data",
        dataValue: "Email address, purchase history, browsing data, preferences",
        purposeValue: "Newsletters, personalized offers, advertising optimization",
        legalBasisValue: "Consent (GDPR Article 6(1)(a))",
        retentionValue: "Until consent withdrawal + 1 year for statistics"
      }
    },
    rights: {
      title: "Your Rights",
      information: {
        title: "Right to information",
        description: "You have the right to know what data about you is collected, how it is used and with whom it is shared."
      },
      access: {
        title: "Right to access",
        description: "You can request a copy of all data processed about you. We respond within 30 days."
      },
      rectification: {
        title: "Right to rectification",
        description: "You can request correction of inaccurate or incomplete personal data."
      },
      erasure: {
        title: "Right to erasure",
        description: "You can request deletion of your data if there is no legal basis to store it."
      },
      portability: {
        title: "Right to portability",
        description: "You can receive your data in a structured format and transfer it elsewhere."
      },
      withdrawal: {
        title: "Right to withdrawal",
        description: "You can withdraw your consent to data processing at any time."
      }
    },
    dataSharing: {
      title: "With whom we share data",
      providers: {
        title: "Service Providers",
        delivery: "Delivery services:",
        deliveryValue: "Omniva - delivery data",
        payment: "Payment systems:",
        paymentValue: "Stripe, banks - payment data",
        it: "IT services:",
        itValue: "Supabase (database), Google (analytics), Facebook (advertising)"
      },
      thirdParty: {
        title: "Data transfer to third countries",
        intro: "Some of our service providers may be located outside the EEA:",
        usa: "USA: Google, Facebook - EU-US Data Privacy Framework applies",
        gdpr: "All transfers are made in accordance with GDPR requirements",
        secure: "We only use service providers with appropriate safeguards"
      }
    },
    security: {
      title: "Data Security",
      technical: {
        title: "Technical measures:",
        ssl: "SSL encryption for data transmission",
        encryption: "Password encryption in database",
        updates: "Regular security updates",
        access: "Access control and audit logs",
        backup: "Data backups"
      },
      organizational: {
        title: "Organizational measures:",
        training: "Employee training on data protection",
        accessManagement: "Access rights management",
        audits: "Regular security audits",
        incidents: "Incident response procedures",
        contracts: "Data processing agreements with providers"
      }
    },
    minors: {
      title: "Minors' data",
      description: "Our services are intended for persons aged 16 and over. If you are under 16, please obtain parental or guardian consent before registering on our website or providing personal data.",
      removal: "If we learn that we have collected data from a minor without proper consent, we will delete it immediately."
    },
    contact: {
      title: "How to contact us and file a complaint",
      dataProtection: {
        title: "Data protection inquiries",
        email: "Email:",
        phone: "Phone:",
        postal: "Mail:",
        responseTime: "We respond to inquiries within 30 calendar days"
      },
      complaints: {
        title: "Complaints to supervisory authority",
        authority: "State Data Protection Inspectorate",
        address: "Address: L. Stuokos-Gucevičiaus str. 11A, 01122 Vilnius",
        email: "Email: ada@ada.lt",
        phone: "Phone: +370 5 279 1445",
        website: "Website: www.ada.lt"
      }
    },
    updates: {
      title: "Policy Changes",
      description: "We may change this privacy policy to comply with new laws, technological changes or our business needs. We will inform you about significant changes:",
      notification1: "By email to registered users (30 days in advance)",
      notification2: "By posting a notice on the website",
      notification3: "By updating the \"Last Updated\" date in this document",
      agreement: "By continuing to use our services after the changes are published, you agree to the new policy version."
    }
  },

  // Admin
  admin: {
    panel: 'Admin Panel',
    backToStore: 'Back to Store',
    dashboard: 'Dashboard',
    heroSection: 'Hero Section',
    products: 'Products',
    categories: 'Categories',
    skinTypes: 'Skin Types',
    purpose: 'Purpose',
    brands: 'Brands',
    translations: 'Translations',
    suppliers: 'Suppliers',
    customerOrders: 'Customer Orders',
    supplierOrders: 'Supplier Orders',
    invoices: 'Invoices',
    carts: 'Carts',
    loyaltyPoints: 'Loyalty Points',
    users: 'Users',
    subscribers: 'Subscribers',
    contactMessages: 'Contact Messages',
    marketingEmails: 'Marketing Emails',
    settings: 'Settings',
    shippingSettings: {
      title: "Shipping Settings",
      save: "Save",
      saving: "Saving...",
      loading: "Loading...",
      deliveryMethods: "Delivery Methods",
      standardDelivery: "Standard Delivery",
      omnivaParcelMachines: "Omniva Parcel Machines",
      salonPickup: "Salon Pickup",
      freeShipping: "Free Shipping",
      freeShippingThreshold: "Minimum amount for free shipping (€)",
      freeShippingThresholdPlaceholder: "25.35",
      freeShippingDescription: "Customers will get free shipping if order amount exceeds this sum",
      standardShippingCost: "Standard shipping cost (€)",
      standardShippingCostPlaceholder: "5.99",
      standardShippingDescription: "This amount will be added to the order if free shipping threshold is not reached",
      deliveryTime: "Delivery Time",
      deliveryTimeTextLt: "Delivery time text (LT)",
      deliveryTimeTextEn: "Delivery time text (EN)",
      deliveryTimeTextLtPlaceholder: "Delivery in 2-3 business days",
      deliveryTimeTextEnPlaceholder: "Delivery in 2-3 business days",
      deliveryTimeDescription: "Text that will be shown in cart and delivery information",
      preview: "Preview",
      previewFreeShipping: "Free shipping:",
      previewOrdersFrom: "For orders from",
      previewStandardShipping: "Standard shipping:",
      previewOrdersUpTo: "for orders up to",
      previewDeliveryTime: "Delivery time:",
      successTitle: "Success",
      successDescription: "Shipping settings saved",
      errorTitle: "Error",
      errorLoadDescription: "Failed to load shipping settings",
      errorSaveDescription: "Failed to save shipping settings",
    },
    
    // Purpose (Paskirtis)
    paskirtis: {
      title: "Purpose Management",
      addPurpose: "Add Purpose",
      editPurpose: "Edit Purpose",
      purposes: "Purposes",
      searchPlaceholder: "Search purposes...",
      name: "Name",
      nameRequired: "Name is required",
      namePlaceholder: "E.g.: Face care",
      slug: "Slug",
      slugPlaceholder: "Leave empty to auto-generate",
      slugDescription: "URL address. If left empty, will be generated from the name.",
      description: "Description",
      descriptionPlaceholder: "Purpose description...",
      actions: "Actions",
      edit: "Edit",
      delete: "Delete",
      cancel: "Cancel",
      update: "Update",
      add: "Add",
      loading: "Loading...",
      deleteConfirmTitle: "Are you sure you want to delete this purpose?",
      deleteConfirmDescription: "This action cannot be undone. The purpose will be permanently deleted.",
      successTitle: "Success",
      successUpdate: "Purpose successfully updated",
      successAdd: "Purpose successfully added",
      successDelete: "Purpose successfully deleted",
      errorTitle: "Error",
      errorLoad: "Failed to load purposes",
      errorSave: "Failed to save purpose",
      errorDelete: "Failed to delete purpose",
    },
    salonLocations: 'Salon Locations',
    omnivaSettings: 'Omniva Settings',
    stripeSettings: 'Stripe Settings',
    features: 'Features',
    services: 'Services',
    specialists: 'Specialists',
    bookings: 'Bookings',
    loading: 'Loading...',
    quickActions: 'Quick Actions',
    addProduct: 'Add Product',
    viewOrders: 'View Orders',
    manageUsers: 'Manage Users',
    recentOrders: 'Recent Orders',
    orderNumber: 'Order Number',
    amount: 'Amount',
    status: 'Status',
    date: 'Date',
    noOrders: 'No orders',
    admin: 'Admin',
    moderator: 'Moderator',
    statusPending: 'Pending',
    statusProcessing: 'Processing',
    statusShipped: 'Shipped',
    statusDelivered: 'Delivered',
    statusCancelled: 'Cancelled',
    
    // Subscribers
    subscribersManagement: 'Subscriber Management',
    exportEmails: 'Export email addresses',
    totalSubscribers: 'Total Subscribers',
    activeSubscribers: 'Active Subscribers',
    unsubscribed: 'Unsubscribed',
    subscribersList: 'Subscribers',
    searchByEmail: 'Search by email address...',
    emailAddress: 'Email Address',
    subscriberStatus: 'Status',
    subscriptionDate: 'Subscription Date',
    unsubscribeDate: 'Unsubscribe Date',
    subscriberType: 'Type',
    statusUnsubscribed: 'Unsubscribed',
    statusActive: 'Active',
    registeredUser: 'Registered User',
    guest: 'Guest',
    noSubscribersFound: 'No subscribers found',
    noSubscribers: 'No subscribers',
    errorLoadingSubscribers: 'Failed to load subscribers',
    exportSuccess: 'Exported {count} subscriber email addresses',
    productCodeBarcode: 'Product Code / Barcode (optional)',
    usedForScanner: 'Used for scanner',
    eanUpcCode: 'EAN, UPC or other code',
    barcodeDescription: 'Enter the product barcode (EAN, UPC) so customers can find it with the barcode scanner',
    gtinCode: 'GTIN Code (optional)',
    gtinUsedFor: 'ChatGPT Shopping',
    gtinPlaceholder: 'GTIN, EAN-13, UPC-A or ISBN',
    gtinDescription: 'Manufacturer identification number used for ChatGPT Shopping and other commerce platforms',
    subscriptionPlans: 'Subscription Plans',
    
    // Product Form
    productForm: {
      addNewProduct: "Add New Product",
      editProduct: "Edit Product",
      name: "Name",
      namePlaceholder: "Product name",
      nameRequired: "Name is required",
      slug: "SEO URL (slug)",
      slugPlaceholder: "product-name (leave empty for automatic generation)",
      slugHint: "If left empty, slug will be automatically generated from product name and brand",
      brand: "Brand",
      brandRequired: "Brand is required",
      brandPlaceholder: "Select brand",
      categories: "Categories (select one or more)",
      categoriesRequired: "At least one category is required",
      price: "Price (€)",
      pricePlaceholder: "0.00",
      priceRequired: "Price is required",
      discount: "Discount (%)",
      discountPlaceholder: "0",
      priceAfterDiscount: "Price after discount:",
      youSave: "You save:",
      supplier: "Supplier",
      supplierRequired: "Supplier is required",
      supplierPlaceholder: "Select supplier",
      supplierPrice: "Supplier Price (€)",
      supplierPageLink: "Supplier Page Link (optional)",
      skinType: "Skin Type",
      skinTypeRequired: "Skin type is required",
      skinTypePlaceholder: "Select skin type",
      purpose: "Purpose",
      purposePlaceholder: "Not selected",
      stockQuantity: "Stock Quantity",
      stockQuantityPlaceholder: "0",
      stockQuantityRequired: "Stock quantity is required",
      images: "Product Images",
      imagesRequired: "At least one image is required",
      description: "Description",
      descriptionPlaceholder: "Product description...",
      descriptionEn: "Description (EN)",
      descriptionEnPlaceholder: "Product description in English...",
      ingredients: "Ingredients",
      ingredientsPlaceholder: "Product ingredients...",
      ingredientsEn: "Ingredients (EN)",
      ingredientsEnPlaceholder: "Product ingredients in English...",
      usage: "Usage",
      usagePlaceholder: "How to use the product...",
      usageEn: "Usage (EN)",
      usageEnPlaceholder: "How to use the product in English...",
      pdfFiles: "PDF Files",
      isNew: "New Product",
      isNewDescription: "Mark as new product",
      isBestseller: "Bestseller",
      isBestsellerDescription: "Mark as bestseller",
      recommendedByCosmetologists: "Recommended by Cosmetologists",
      recommendedByCosmetologistsDescription: "Mark as recommended by cosmetologists",
      showPriceToUnregistered: "Price Visible to All",
      showPriceToUnregisteredDescription: "Price will be visible to unregistered users",
      requiresConsultation: "Requires Consultation",
      requiresConsultationDescription: "Product can only be purchased after consultation",
      hidePriceWithoutConsultation: "Hide Price Without Consultation",
      hidePriceWithoutConsultationDescription: "Price will only be visible after consultation is approved",
      needsAttention: "Needs Attention",
      needsAttentionDescription: "Mark if product needs administrator attention",
      forProfessionalUseOnly: "For Professional Use Only",
      forProfessionalUseOnlyDescription: "Mark if product is for professional use only",
      isCreatedManually: "Created Manually",
      isCreatedManuallyDescription: "Indicates whether product was created manually or imported/copied",
      isInactive: "Inactive Product",
      isInactiveDescription: "Inactive products are hidden from customers (not shown in search, lists, page cannot be accessed)",
      cancel: "Cancel",
      create: "Create Product",
      update: "Update Product",
      loading: "Loading...",
      success: "Success",
      productCreated: "Product created successfully",
      productUpdated: "Product updated successfully",
      error: "Error",
      productCreateError: "Failed to create product",
      productUpdateError: "Failed to update product",
    },

    // Category List
    categoryList: {
      title: 'Category Management',
      addCategory: 'Add Category',
      categories: 'Categories',
      search: 'Search categories...',
      loading: 'Loading...',
      image: 'Image',
      nameLt: 'Name (LT)',
      nameEn: 'Name (EN)',
      slug: 'Slug',
      descriptionLt: 'Description (LT)',
      descriptionEn: 'Description (EN)',
      status: 'Status',
      filters: 'Filters',
      topNav: 'Top Nav.',
      order: 'Order',
      actions: 'Actions',
      active: 'Active',
      inactive: 'Inactive',
      yes: 'Yes',
      no: 'No',
      noImage: 'None',
      editCategory: 'Edit Category',
      deleteTitle: 'Are you sure you want to delete this category?',
      deleteDescription: 'This action cannot be undone. The category will be permanently deleted.',
      deleteCancel: 'Cancel',
      deleteConfirm: 'Delete',
      deleteSuccess: 'Category deleted successfully',
      deleteError: 'Failed to delete category',
      loadError: 'Failed to load categories',
    },

    // Category Form
    categoryForm: {
      titleEdit: 'Edit Category',
      titleAdd: 'Add Category',
      nameLt: 'Name (LT)',
      nameLtPlaceholder: 'Category name',
      nameLtRequired: 'Name is required',
      nameEn: 'Name (EN)',
      nameEnPlaceholder: 'Category name in English',
      slug: 'Slug',
      slugPlaceholder: 'category-slug',
      slugRequired: 'Slug is required',
      slugDescription: 'URL-friendly name (used in links)',
      sortOrder: 'Sort Order',
      sortOrderDescription: 'Lower numbers appear first',
      sortOrderMin: 'Order cannot be negative',
      image: 'Category Image',
      descriptionLt: 'Description (LT)',
      descriptionLtPlaceholder: 'Category description...',
      descriptionEn: 'Description (EN)',
      descriptionEnPlaceholder: 'Category description in English...',
      isActive: 'Active Category',
      isActiveDescription: 'Whether category is visible on the website',
      showInMenu: 'Show in Filters',
      showInMenuDescription: 'Whether category will be shown in filters and search',
      showInHeader: 'Show in Top Navigation',
      showInHeaderDescription: 'Whether category will be shown in top navigation menu',
      cancel: 'Cancel',
      update: 'Update Category',
      create: 'Create Category',
      updateSuccess: 'Category updated successfully',
      createSuccess: 'Category created successfully',
      updateError: 'Failed to update category',
      createError: 'Failed to create category',
    },

    // Skin Types
    skinTypesList: {
      title: 'Skin Types Management',
      addSkinType: 'Add Skin Type',
      skinTypes: 'Skin Types',
      search: 'Search skin types...',
      loading: 'Loading...',
      name: 'Name',
      slug: 'Slug',
      description: 'Description',
      actions: 'Actions',
      editSkinType: 'Edit Skin Type',
      addNewSkinType: 'Add Skin Type',
      deleteTitle: 'Are you sure you want to delete this skin type?',
      deleteDescription: 'This action cannot be undone. The skin type will be permanently deleted.',
      deleteCancel: 'Cancel',
      deleteConfirm: 'Delete',
      deleteSuccess: 'Skin type deleted successfully',
      deleteError: 'Failed to delete skin type',
      loadError: 'Failed to load skin types',
      nameRequired: 'Name is required',
      nameLabel: 'Name *',
      namePlaceholder: 'E.g.: Dry skin',
      slugLabel: 'Slug',
      slugPlaceholder: 'Leave empty for automatic generation',
      slugDescription: 'URL address. If left empty, will be generated from name.',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Skin type description...',
      cancel: 'Cancel',
      update: 'Update',
      add: 'Add',
      updateSuccess: 'Skin type updated successfully',
      addSuccess: 'Skin type added successfully',
      saveError: 'Failed to save skin type',
    },
    
    // Products page
    productsManagement: 'Products Management',
    regenerateSlugs: 'Regenerate Slugs',
    productsCount: 'Products',
    searchProducts: 'Search products...',
    needsAttention: 'Needs attention',
    forProfessionals: 'For professionals:',
    inactive: 'Inactive:',
    manuallyCreated: 'Manually created:',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    image: 'Img',
    name: 'Name',
    brand: 'Brand',
    category: 'Category',
    price: 'Price',
    discount: 'Discount',
    stock: 'Stock',
    tags: 'Tags',
    actions: 'Actions',
    viewMore: 'All skin types',
    editProduct: 'Edit product',
    deleteProduct: 'Delete product',
    deleteConfirmTitle: 'Are you sure you want to delete this product?',
    deleteConfirmDescription: 'This action is irreversible.',
    delete: 'Delete',
    cancel: 'Cancel',
    errorTitle: 'Error',
    errorLoadProducts: 'Failed to load products',
    errorDeleteProduct: 'Failed to delete product',
    successTitle: 'Success',
    successDeleteProduct: 'Product deleted successfully',
    infoTitle: 'Information',
    noProductsFound: 'No products found',
    slugsRegeneratedSuccess: 'Successfully updated {count} product slugs. Errors: {errors}',
    errorRegenerateSlugs: 'Failed to regenerate slugs',
  },

  // Subscription
  subscription: {
    title: 'Subscription',
    yourSubscription: 'Your Subscription',
    subscriptionPlans: 'Subscription Plans',
    subscribe: 'Subscribe',
    alreadySubscribed: 'Already subscribed',
    active: 'Active',
    price: 'Price',
    renews: 'Renews',
    cancelSubscription: 'Cancel Subscription',
    resumeSubscription: 'Resume Subscription',
    cancelConfirmTitle: 'Cancel subscription?',
    cancelConfirmDescription: 'Your subscription will be canceled at the end of the period. You will have access until then.',
    confirm: 'Confirm',
    cancel: 'Cancel',
    willCancelAtPeriodEnd: 'Subscription will be canceled at period end',
    noSubscription: 'You currently do not have an active subscription.',
    subscribeAndSave: 'Subscribe and get 10% discount on all products',
    discountApplied: 'You get {discount}% discount on all products!',
    month: 'month',
    year: 'year',
    noPlansAvailable: 'No subscription plans available',
    perMonth: '/ month',
    perYear: '/ year',
    productSubscriptions: 'Product Subscriptions',
    productSubscriptionsDesc: 'Manage your active product subscriptions',
  },

  // Omniva Settings
  omnivaSettings: {
    title: 'Omniva Settings',
    save: 'Save',
    saving: 'Saving...',
    apiConfiguration: 'API Configuration',
    apiUrl: 'API URL',
    apiUsername: 'API Username',
    apiPassword: 'API Password',
    contractNumber: 'Contract Number',
    testMode: 'Test Mode',
    senderInformation: 'Sender Information',
    senderName: 'Sender Name',
    address: 'Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country',
    phoneNumber: 'Phone Number',
    emailAddress: 'Email Address',
    serviceConfiguration: 'Service Configuration',
    defaultServiceCode: 'Default Service Code',
    labelFormat: 'Label Format',
    deliveryMethods: 'Delivery Methods',
    parcelMachineService: 'Parcel Machine Service',
    courierService: 'Courier Service',
    automation: 'Automation',
    autoCreateShipments: 'Auto-create Shipments',
    autoCreateShipmentsDesc: 'Automatically create shipments when order is confirmed',
    parcelMachinesManagement: 'Parcel Machines Data Management',
    parcelMachinesCache: 'Parcel Machines List Cache',
    parcelMachinesCacheDesc: 'Data is automatically updated every 24 hours from https://www.omniva.lt/locations.json',
    refreshNow: 'Refresh Now',
    refreshing: 'Refreshing...',
    dataSource: 'Data Source:',
    omnivaPublicApi: 'Omniva Public API',
    cacheValidity: 'Cache Validity:',
    hours24: '24 hours',
    howToGetCredentials: 'How to Get Omniva Credentials',
    step1: '<strong>1. Registration:</strong> Fill in the business offer form on the Omniva website',
    step2: '<strong>2. Contract:</strong> Sign a business client agreement with Omniva',
    step3: '<strong>3. API Access:</strong> Contact your business client manager for API access',
    step4: '<strong>4. Testing:</strong> Start with the testing environment before switching to production mode',
    contactInfo: '<strong>Contact:</strong> info@omniva.lt or +370 700 72 727',
    productionEnv: 'Production environment: https://edixml.post.ee',
    testingEnv: 'Testing environment: https://test-edixml.post.ee',
    yourApiUsername: 'Your API username',
    yourApiPassword: 'Your API password',
    yourContractNumber: 'Your Omniva contract number',
    yourCompanyName: 'Your company name',
    streetNumber: 'Street, house number',
    cityPlaceholder: 'Kaunas',
    postalCodePlaceholder: '47222',
    countryPlaceholder: 'LT',
    phonePlaceholder: '+370 684 39040',
    emailPlaceholder: 'info@beaubox.lt',
    serviceCodePlaceholder: 'PA',
    serviceCodeDesc: 'PA - Parcel Machines, CD - Couriers',
    labelFormatPlaceholder: 'PDF',
    savedSuccessTitle: 'Saved!',
    savedSuccessDesc: 'Omniva settings successfully updated',
    errorTitle: 'Error',
    errorLoadSettings: 'Failed to load Omniva settings',
    errorSaveSettings: 'Failed to save Omniva settings',
    refreshSuccessTitle: 'Successfully Refreshed!',
    refreshSuccessDesc: 'Parcel machines list updated. Found {count} parcel machines.',
    errorRefreshCache: 'Failed to refresh parcel machines list',
  },
  
  adminSuppliers: {
    title: 'Suppliers',
    addButton: 'Add supplier',
    searchPlaceholder: 'Search suppliers...',
    loading: 'Loading...',
    table: {
      name: 'Name',
      contactPerson: 'Contact person',
      email: 'Email',
      phone: 'Phone',
      status: 'Status',
      actions: 'Actions'
    },
    status: {
      active: 'Active',
      inactive: 'Inactive'
    },
    form: {
      editTitle: 'Edit supplier',
      addTitle: 'Add supplier',
      name: 'Name',
      nameRequired: 'Name is required',
      namePlaceholder: 'Supplier name',
      contactPerson: 'Contact person',
      contactPersonPlaceholder: 'First Last',
      email: 'Email',
      emailInvalid: 'Invalid email format',
      emailPlaceholder: 'info@supplier.com',
      phone: 'Phone',
      phonePlaceholder: '+370 600 00000',
      website: 'Website',
      websiteInvalid: 'Invalid URL format',
      websitePlaceholder: 'https://supplier.com',
      address: 'Address',
      addressPlaceholder: 'Street 1, City',
      notes: 'Notes',
      notesPlaceholder: 'Additional information about the supplier...',
      isActive: 'Active',
      isActiveDescription: 'Is this supplier active?',
      cancel: 'Cancel',
      create: 'Create',
      update: 'Update'
    },
    toast: {
      updateSuccess: 'Success',
      updateSuccessDesc: 'Supplier updated successfully',
      createSuccess: 'Success',
      createSuccessDesc: 'Supplier created successfully',
      deleteSuccess: 'Success',
      deleteSuccessDesc: 'Supplier deleted successfully',
      error: 'Error',
      loadError: 'Failed to load suppliers',
      saveError: 'Failed to save supplier',
      deleteError: 'Failed to delete supplier'
    },
    deleteDialog: {
      title: 'Are you sure you want to delete this supplier?',
      description: 'This action cannot be undone.',
      cancel: 'Cancel',
      delete: 'Delete'
    },
    notFound: 'No suppliers found'
  },

  // Admin Invoices
  adminInvoices: {
    title: 'Invoices',
    loading: 'Loading...',
    search: 'Search by number, name or email...',
    filterByStatus: 'Filter by status',
    allStatuses: 'All statuses',
    noInvoices: 'No invoices found',
    table: {
      number: 'Number',
      customer: 'Customer',
      date: 'Date',
      amount: 'Amount',
      status: 'Status',
      paid: 'Paid',
      actions: 'Actions',
      yes: 'Yes',
      no: 'No',
    },
    status: {
      draft: 'Draft',
      issued: 'Issued',
      sent: 'Sent',
      paid: 'Paid',
      unpaid: 'Unpaid',
      overdue: 'Overdue',
      cancelled: 'Cancelled',
    },
    dialog: {
      title: 'Invoice',
      vatInvoice: 'VAT INVOICE',
      invoice: 'INVOICE',
      viewTooltip: 'View invoice',
      created: 'Created',
      edit: 'Edit',
      description: 'View and edit invoice information',
      customerInfo: 'Customer Information',
      customerShort: 'Customer',
      invoiceInfo: 'Invoice Information',
      paymentInfo: 'Payment Information',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      companyCode: 'Company Code',
      vatCode: 'VAT Code',
      statusLabel: 'Status',
      paidLabel: 'Paid',
      yesLabel: 'Yes',
      noLabel: 'No',
      issueDate: 'Issue Date',
      dueDate: 'Due Date',
      dueDateNotSet: 'Not set',
      paymentTerms: 'Payment Terms',
      paymentTermsPlaceholder: 'e.g., Net 30, Due on receipt',
      paymentTermsPlaceholderEdit: 'E.g., 30 days',
      notes: 'Notes',
      notesPlaceholder: 'Additional information...',
      notesEmpty: 'None',
      items: 'Invoice Items',
      itemsTable: {
        product: 'Product',
        quantity: 'Quantity',
        unitPrice: 'Unit Price',
        price: 'Price',
        total: 'Amount',
        amount: 'Total',
      },
      subtotal: 'Subtotal (excl. VAT)',
      subtotalNoVat: 'Subtotal',
      subtotalLabel: 'Subtotal:',
      discount: 'Discount:',
      vat: 'VAT',
      vatLabel: 'VAT:',
      total: 'Total',
      totalLabel: 'Total:',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
      close: 'Close',
      downloadPdf: 'Download PDF',
      sendEmail: 'Send via Email',
      sending: 'Sending...',
      pdf: {
        vatInvoice: 'VAT INVOICE',
        invoice: 'INVOICE',
        number: 'Number:',
        date: 'Date:',
        dueDate: 'Due Date:',
        notSet: 'Not set',
        seller: 'SELLER:',
        customer: 'CUSTOMER:',
        companyCode: 'Company Code:',
        vatCode: 'VAT Code:',
        items: 'ITEMS:',
        product: 'Product',
        quantity: 'Quantity',
        price: 'Price',
        amount: 'Amount',
        subtotalNoVatLabel: 'Subtotal:',
        subtotalLabel: 'Subtotal (excl. VAT):',
        vatLabel: 'VAT:',
        totalLabel: 'TOTAL:',
        notes: 'Notes:',
        paymentTerms: 'Payment Terms:',
      }
    },
    toast: {
      errorLoading: 'Failed to load invoices',
      errorLoadingItems: 'Failed to load invoice items',
      successUpdated: 'Invoice updated',
      errorUpdating: 'Failed to update invoice',
      errorPdfNotFound: 'PDF file not found',
      errorDownloading: 'Failed to download PDF',
      success: 'Success!',
      updateSuccess: 'Invoice updated successfully',
      updateError: 'Failed to update invoice',
      emailSent: 'Email sent!',
      emailSentDescription: 'Invoice sent to customer via email',
      emailError: 'Failed to send email',
      error: 'Error'
    },
  },

  // Admin Users
  adminUsers: {
    title: 'User Management',
    users: 'Users',
    userId: 'User ID',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    role: 'Role',
    registrationDate: 'Registration Date',
    actions: 'Actions',
    edit: 'Edit',
    search: 'Search users...',
    filterAllRoles: 'All Roles',
    filterByRole: 'Filter by role',
    roleUser: 'User',
    roleAdmin: 'Administrator',
    roleModerator: 'Moderator',
    roleAdmins: 'Administrators',
    roleModerators: 'Moderators',
    roleUsers: 'Users',
    editUser: 'Edit User',
    editUserDescription: 'Change user profile and contact details',
    personalInfo: 'Personal Information',
    companyInfo: 'Company Information',
    accountInfo: 'Account Information',
    shippingAddress: 'Shipping Address',
    companyCode: 'Company Code',
    companyVat: 'VAT Code',
    password: 'New Password',
    passwordPlaceholder: 'Leave empty to keep current password',
    passwordTooShort: 'Password must be at least 6 characters',
    street: 'Street and Number',
    streetPlaceholder: 'E.g. Romainiškių St. 47 - 1',
    city: 'City',
    cityPlaceholder: 'E.g. Vilnius',
    postalCode: 'Postal Code',
    postalCodePlaceholder: 'E.g. 08000',
    country: 'Country',
    countryPlaceholder: 'E.g. Lithuania',
    systemInfo: 'System Information',
    userIdLabel: 'User ID',
    firstNamePlaceholder: 'Enter first name',
    lastNamePlaceholder: 'Enter last name',
    phonePlaceholder: 'Enter phone number',
    companyCodePlaceholder: 'Enter company code',
    companyVatPlaceholder: 'Enter VAT code',
    emailPlaceholder: 'Enter email address',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    saving: 'Saving...',
    loading: 'Loading...',
    noUsers: 'No users',
    noUsersFound: 'No users found',
    emailNotAvailable: 'Email not available',
    toast: {
      errorLoading: 'Error',
      errorLoadingDesc: 'Failed to load users',
      roleSuccess: 'Success',
      roleSuccessDesc: 'User role successfully updated',
      roleError: 'Error',
      roleErrorDesc: 'Failed to update user role',
      lastAdminError: 'Cannot Remove',
      lastAdminErrorDesc: 'Cannot remove the last administrator. At least one administrator must remain.',
      userSuccess: 'Success',
      userSuccessDesc: 'User data updated',
      userError: 'Error',
      userErrorDesc: 'Failed to update user data',
      emailWarning: 'Warning',
      emailWarningDesc: 'Profile updated, but email address could not be changed',
      passwordWarning: 'Warning',
      passwordWarningDesc: 'Profile updated, but password could not be changed',
    },
  },

  // Supplier Orders
  userCarts: {
    title: 'User Carts',
    refresh: 'Refresh',
    searchPlaceholder: 'Search by email or name...',
    showOnlyUnapproved: 'Show only unapproved consultations',
    items: 'Items',
    consultations: 'Consultations',
    approved: 'Approved',
    needsConsultation: 'Needs consultation',
    consultationManagement: 'Consultation Management:',
    approve: 'Approve',
    revoke: 'Revoke',
    loading: 'Loading...',
    noCartsTitle: 'No Carts',
    noCartsDescription: 'Currently no users with items in their cart',
    noSearchResults: 'No carts found matching search criteria',
    approveDialogTitle: 'Approve Consultation',
    user: 'User',
    product: 'Product',
    notesLabel: 'Notes (optional)',
    notesPlaceholder: 'Enter notes about the consultation...',
    cancel: 'Cancel',
    confirmApproval: 'Confirm Approval',
    alreadyApprovedTitle: 'Already Approved',
    alreadyApprovedDescription: 'This consultation has already been approved',
    approvalSuccessTitle: 'Consultation Approved',
    approvalSuccessDescription: 'User can now purchase this product',
    approvalErrorTitle: 'Error',
    approvalErrorDescription: 'Failed to approve consultation',
    revokeSuccessTitle: 'Approval Revoked',
    revokeSuccessDescription: 'Consultation approval has been revoked',
    revokeErrorTitle: 'Error',
    revokeErrorDescription: 'Failed to revoke approval',
    loadErrorTitle: 'Error',
    loadErrorDescription: 'Failed to load user carts',
  },

  supplierOrders: {
    title: 'Supplier Orders',
    description: 'Manage orders to suppliers',
    allOrders: 'All Supplier Orders',
    allOrdersDescription: 'View and manage all orders to suppliers',
    loading: 'Loading...',
    noOrders: 'No supplier orders found',
    orderDate: 'Order Date',
    supplier: 'Supplier',
    status: 'Status',
    productCount: 'Product Count',
    amount: 'Amount',
    expectedDeliveryDate: 'Expected Delivery Date',
    actions: 'Actions',
    statusPending: 'Pending',
    statusOrdered: 'Ordered',
    statusShipped: 'Shipped',
    statusDelivered: 'Delivered',
    statusCancelled: 'Cancelled',
    editOrderTitle: 'Edit Supplier Order',
    editOrderDescription: 'Update order information',
    viewOrderTitle: 'Supplier Order Details',
    viewOrderDescription: 'View order information',
    amountLabel: 'Amount (€)',
    notes: 'Notes',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    products: 'Products',
    product: 'Product',
    brand: 'Brand',
    quantity: 'Quantity',
    price: 'Price',
    orderNumber: 'Order No.',
    orderUpdated: 'Supplier order updated',
    orderUpdateError: 'Error updating order',
    orderDeleted: 'Supplier order deleted',
    orderDeleteError: 'Error deleting order',
    confirmDelete: 'Are you sure you want to delete this supplier order?',
    exportedToCSV: 'Order exported to CSV',
    exportError: 'Error exporting to CSV',
    noSupplierEmail: 'Supplier does not have an email address',
    emailSent: 'Order sent via email',
    emailError: 'Error sending email',
  },

  // Invoice Manager Button
  invoiceManager: {
    checking: 'Checking...',
    create: 'Create Invoice',
    view: 'View Invoice',
  },

  // Invoice Creation Dialog
  invoiceCreation: {
    title: 'Invoice Creation',
    description: 'Create invoice for order',
    orderSummary: 'Order Amount',
    customer: 'Customer',
    dueDate: 'Payment Due Date',
    paymentTerms: 'Payment Terms',
    paymentTermsPlaceholder: 'e.g., Net 30, Pay immediately',
    includeVat: 'Include VAT',
    includeVatDescription: 'Include VAT in invoice calculations? (Rate: {rate}%)',
    vatAmount: 'VAT Amount',
    notes: 'Notes (optional)',
    notesPlaceholder: 'Additional information for the invoice...',
    cancelButton: 'Cancel',
    createButton: 'Create Invoice',
    creating: 'Creating...',
    successTitle: 'Invoice Created!',
    successDescription: 'What would you like to do next?',
    downloadPdf: 'Download PDF',
    sendEmail: 'Send via Email',
    downloading: 'Downloading...',
    sending: 'Sending...',
    close: 'Close',
    toast: {
      successCreated: 'Invoice {number} created successfully',
      errorCreating: 'Failed to create invoice',
      emailSent: 'Email sent!',
      emailSentDescription: 'Invoice sent to customer via email',
      errorSendingEmail: 'Failed to send email',
    },
  },

  // Invoice Review Dialog
  invoiceReview: {
    title: 'Invoice',
    vatInvoice: 'VAT INVOICE',
    regularInvoice: 'INVOICE',
    created: 'Created',
    customer: 'Customer',
    paymentDetails: 'Payment Details',
    issueDate: 'Issue Date',
    dueDate: 'Payment Due Date',
    status: 'Status',
    paymentTerms: 'Payment Terms',
    paymentTermsPlaceholder: 'e.g., Net 30',
    notes: 'Notes',
    notesPlaceholder: 'Additional notes...',
    items: 'Items',
    itemsTable: {
      product: 'Product',
      description: 'Description',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      total: 'Total',
    },
    subtotal: 'Subtotal excl. VAT',
    regularSubtotal: 'Subtotal',
    vat: 'VAT',
    total: 'TOTAL',
    editButton: 'Edit',
    cancelButton: 'Cancel',
    saveButton: 'Save',
    downloadPdf: 'Download PDF',
    sendEmail: 'Send via Email',
    saving: 'Saving...',
    sending: 'Sending...',
    toast: {
      successUpdated: 'Invoice updated successfully',
      errorUpdating: 'Failed to update invoice',
      emailSent: 'Email sent!',
      emailSentDescription: 'Invoice sent to customer via email',
      errorSendingEmail: 'Failed to send email',
    },
  },

  // Admin Loyalty Points
  loyaltyPoints: {
    pageTitle: 'Loyalty Points',
    addRemovePoints: 'Add/Remove Points',
    editPoints: 'Edit Loyalty Points',
    userLabel: 'User',
    selectUser: 'Select user',
    actionLabel: 'Action',
    addPoints: 'Add Points',
    removePoints: 'Remove Points',
    pointsAmount: 'Points Amount',
    pointsAmountPlaceholder: '0.00',
    description: 'Description',
    descriptionPlaceholder: 'Enter reason...',
    cancel: 'Cancel',
    submitAdd: 'Add Points',
    submitRemove: 'Remove Points',
    usersAndPoints: 'Users and Points',
    searchUsers: 'Search users...',
    recentActivity: 'Recent Activity',
    pointsAbbr: 'pts.',
    userHistory: 'Loyalty Points History',
    totalPoints: 'Total Points:',
    orderLabel: 'Order:',
    loading: 'Loading...',
    errorLoadingUsers: 'Error',
    errorLoadingUsersDesc: 'Failed to load user data',
    errorLoadingEntries: 'Error',
    errorLoadingEntriesDesc: 'Failed to load loyalty points',
    errorLoadingHistory: 'Error',
    errorLoadingHistoryDesc: 'Failed to load loyalty points history',
    errorLoadingUserHistory: 'Error',
    errorLoadingUserHistoryDesc: 'Failed to load user history',
    errorValidation: 'Error',
    errorValidationDesc: 'Please fill in all fields',
    errorInvalidAmount: 'Error',
    errorInvalidAmountDesc: 'Please enter a valid points amount',
    successTitle: 'Success',
    successAdded: 'Successfully added',
    successRemoved: 'Successfully removed',
    successPoints: 'points',
    errorAdding: 'Error',
    errorAddingDesc: 'Failed to add points',
  },

  oldAdminSettings: {
    title: 'System Settings - old',
    loading: 'Loading...',
    sections: {
      general: 'General Settings',
      contact: 'Contact Information',
      invoice: 'Invoice Settings',
      payment: 'Payment Settings',
      cache: 'Cache Management',
      system: 'System Information',
      migration: 'Image Migration',
      sitemap: 'Sitemap Generation',
    },
    general: {
      adminEmail: 'Admin email',
      adminEmailPlaceholder: 'admin@example.com',
      adminEmailDescription: 'Email for system notifications',
      contactEmail: 'Contact email',
      contactEmailPlaceholder: 'info@example.com',
      contactEmailDescription: 'Public contact email',
      phone: 'Phone',
      phonePlaceholder: '+370 600 00000',
      address: 'Address',
      addressPlaceholder: 'Enter company address',
      siteTitle: 'Site title',
      siteTitlePlaceholder: 'My Store',
      companyName: 'Company name',
      companyNamePlaceholder: 'Company LLC',
      logo: 'Logo',
      logoDescription: 'Upload site logo',
      save: 'Save settings',
      saving: 'Saving...',
      emailDomain: 'Email domain',
      emailDomainPlaceholder: 'example.com',
      emailDomainDescription: 'Domain for sending emails from the system',
      facebookUrl: 'Facebook URL',
      instagramUrl: 'Instagram URL',
      youtubeUrl: 'YouTube URL',
      companyPhone: 'Company phone',
      companyEmail: 'Company email',
      companyAddress: 'Company address',
    },
    invoice: {
      vatCode: 'VAT code',
      vatCodePlaceholder: 'LT123456789',
      companyCode: 'Company code',
      companyCodePlaceholder: '123456789',
      sellerName: 'Seller name',
      sellerNamePlaceholder: 'Company LLC',
      sellerAddress: 'Seller address',
      sellerAddressPlaceholder: 'Street 1, Vilnius',
      sellerEmail: 'Seller email',
      sellerEmailPlaceholder: 'invoices@example.com',
      sellerPhone: 'Seller phone',
      sellerPhonePlaceholder: '+370 600 00000',
      bankName: 'Bank name',
      bankNamePlaceholder: 'Swedbank AB',
      bankAccount: 'Bank account',
      bankAccountPlaceholder: 'LT123456789012345678',
      bankSwift: 'SWIFT code',
      bankSwiftPlaceholder: 'HABALT22',
      invoicePrefix: 'Invoice prefix',
      invoicePrefixPlaceholder: 'INV-',
      invoiceDescription: 'This information will be displayed on invoices',
      save: 'Save invoice settings',
      saving: 'Saving...',
      vatRate: 'VAT rate (%)',
      vatRatePlaceholder: '21',
      invoiceEnabled: 'Enable invoices',
      invoiceEnabledDescription: 'Allow users to generate invoices',
    },
    payment: {
      payseraId: 'Paysera project ID',
      payseraIdPlaceholder: '123456',
      payseraPassword: 'Paysera password',
      payseraPasswordPlaceholder: 'Enter Paysera password',
      payseraCallbackUrl: 'Callback URL',
      payseraCallbackUrlPlaceholder: 'https://...',
      testMode: 'Test mode',
      testModeDescription: 'Enable Paysera test mode',
      save: 'Save payment settings',
      saving: 'Saving...',
      paymentMethod: 'Payment method',
      paymentMethodDescription: 'Choose Stripe payment method',
      redirect: 'Redirect',
      inline: 'Inline',
    },
    cache: {
      title: 'Cache Management',
      description: 'Clear cache if you see outdated content',
      clearButton: 'Clear cache',
      clearing: 'Clearing...',
      success: 'Cache cleared successfully',
      error: 'Failed to clear cache',
      cacheControlMaxAge: 'Cache-Control Max-Age (seconds)',
      cacheControlMaxAgePlaceholder: '31536000',
      cacheControlMaxAgeDescription: '1 year = 31536000 seconds',
    },
    system: {
      title: 'System Status',
      database: 'Database',
      connected: 'Connected',
      disconnected: 'Disconnected',
      productsCount: 'Products count',
      ordersCount: 'Orders count',
      usersCount: 'Users count',
      viewLogs: 'View logs',
      logsTitle: 'System Logs',
      logsDescription: 'Recent system events and activity',
      recentOrders: 'Recent orders',
      recentProducts: 'Recent products',
      close: 'Close',
      automaticallyUpdated: 'Automatically updated',
      activeRoles: 'Active',
      working: 'Working',
      rlsEnabled: 'RLS enabled',
    },
    toast: {
      saveSuccess: 'Saved!',
      saveSuccessDescription: 'Settings saved successfully',
      saveError: 'Error',
      saveErrorDescription: 'Failed to save settings',
      loadError: 'Failed to load settings',
      invalidEmail: 'Invalid email format',
      emailEmpty: 'Email address cannot be empty',
      emailDomainEmpty: 'Email domain cannot be empty',
      payseraFieldsRequired: 'Project ID and password are required',
      emailUpdated: 'Admin email address updated',
      emailDomainUpdated: 'Email domain updated',
      contactUpdated: 'Contact settings updated',
      logoUpdated: 'Logo updated',
      titleUpdated: 'Site title updated',
      vatUpdated: 'VAT rate updated',
      sellerUpdated: 'Seller information updated',
      invoiceUpdated: 'Invoice settings updated',
      paymentMethodUpdated: 'Payment method updated',
      payseraUpdated: 'Paysera settings updated',
      cacheControlUpdated: 'Cache-Control settings updated',
      logLoadError: 'Failed to load system logs',
    },
  },
  contactMessages: {
    pageTitle: 'Contact Messages',
    cardTitle: 'Contact Messages',
    description: 'Latest messages from the contact form',
    refresh: 'Refresh',
    badge: {
      consultation: 'Consultation',
      message: 'Message',
    },
    phone: 'Tel',
    reply: 'Reply',
    loading: 'Loading...',
    noMessages: 'No messages',
    toast: {
      loadError: 'Failed to load contact messages',
      errorTitle: 'Error',
    },
  },
  marketingEmails: {
    title: "Marketing Emails",
    description: "Send professional marketing emails to your customers",
    templatesCount: "{{count}} templates",
    selectTemplate: "Select Template",
    selectTemplateDescription: "Choose the appropriate template for your campaign",
    configuration: "Configuration",
    configurationDescription: "Set email content and recipients",
    subject: "Subject",
    subjectPlaceholder: "Email subject",
    templateVariables: "Template Variables",
    variablesHelp: "Fill in the values for the variables below. They will be automatically inserted into the email.",
    recipients: "Recipients (comma-separated)",
    recipientsPlaceholder: "email1@example.com, email2@example.com, another@example.com",
    recipientsHelp: "Enter email addresses separated by commas. For example: info@example.com, john@example.com",
    preview: "Preview",
    previewLabel: "Email Preview",
    hide: "Hide",
    send: "Send Emails",
    sending: "Sending...",
    enterValue: "Enter {{variable}} value",
    templates: {
      newProduct: {
        name: "New Product",
        description: "Be the first to try our latest..."
      },
      discount: {
        name: "Discount / Sale",
        description: "Don't miss this special offer..."
      },
      newsletter: {
        name: "Newsletter",
        description: "Learn about news, tips and..."
      },
      monthlyPromo: {
        name: "Monthly Promotion with Products",
        description: "Exclusive products on sale this m..."
      }
    },
    toast: {
      errorTitle: "Error",
      noRecipients: "Enter at least one email address",
      invalidEmails: "Invalid email addresses: {{emails}}",
      sendError: "Failed to send emails",
      successTitle: "Successfully sent!",
      successDescription: "Emails sent to {{count}} recipients"
    }
  },

  adminSettings: {
    title: 'System Settings',
    logoTitle: {
      title: 'Logo and Title Settings',
      siteTitle: 'Site Title',
      siteTitlePlaceholder: 'BeauBox',
      savingTitle: 'Saving...',
      saveTitle: 'Save Title',
      logoLabel: 'Company Logo (optional)',
      savingLogo: 'Saving...',
      saveLogo: 'Save Logo',
      logoHelpText: 'The logo will be displayed next to the site title in the page header'
    },
    contact: {
      title: 'Contact Information and Social Networks',
      phone: 'Phone Number',
      phonePlaceholder: '+370 684 39040',
      email: 'Email Address',
      emailPlaceholder: 'info@beaubox.lt',
      address: 'Address',
      addressPlaceholder: 'Romainiškių st. 47 - 1, Kaunas, Lithuania, LT47222',
      socialNetworks: 'Social Networks',
      facebookUrl: 'Facebook URL',
      facebookPlaceholder: 'https://facebook.com/...',
      instagramUrl: 'Instagram URL',
      instagramPlaceholder: 'https://instagram.com/...',
      youtubeUrl: 'YouTube URL',
      youtubePlaceholder: 'https://youtube.com/...',
      saving: 'Saving...',
      save: 'Save Contact Settings'
    },
    email: {
      title: 'Email Settings',
      adminEmail: 'Administrator Email',
      adminEmailPlaceholder: 'admin@beaubox.lt',
      adminEmailHelp: 'Contact form messages will be sent to this email',
      emailDomain: 'Email Sending Domain',
      emailDomainPlaceholder: 'beaubox.lt',
      emailDomainHelp: 'Domain from which system emails will be sent (invoices, etc.)'
    },
    seller: {
      title: 'Seller Information for Invoices',
      companyName: 'Company Name',
      companyNamePlaceholder: 'BeauBox UAB',
      companyCode: 'Company Code',
      companyCodePlaceholder: '123456789',
      vatCode: 'VAT Payer Code',
      vatCodePlaceholder: 'LT123456789',
      bankName: 'Bank',
      bankNamePlaceholder: 'Swedbank AB',
      bankAccount: 'Bank Account (IBAN)',
      bankAccountPlaceholder: 'LT123456789012345678',
      bankSwift: 'SWIFT/BIC Code',
      bankSwiftPlaceholder: 'HABALT22',
      saving: 'Saving...',
      save: 'Save Seller Information',
      helpText: 'This information will be automatically included in all generated invoices'
    },
    invoice: {
      title: 'Invoice and VAT Settings',
      functionality: 'Invoice Functionality',
      functionalityHelp: 'Enable or disable the invoice section in user profile pages',
      saving: 'Saving...',
      save: 'Save Invoice Settings',
      paymentMethod: 'Stripe Payment Method',
      paymentMethodHelp: 'Choose whether payment will redirect to Stripe or be processed on the page',
      redirect: 'Redirect',
      inline: 'On Page',
      savePaymentMethod: 'Save Payment Settings',
      vatRate: 'VAT Rate (%)',
      vatRatePlaceholder: '21',
      vatRateHelp: 'This VAT rate will be used for invoice generation (standard 21%)'
    },
    paysera: {
      title: 'Paysera Payment Settings',
      projectId: 'Project ID',
      projectIdPlaceholder: '12345',
      password: 'Password',
      passwordPlaceholder: 'Paysera password',
      callbackUrl: 'Callback URL',
      callbackUrlPlaceholder: 'https://hkownwweihaqtwnjbdzy.supabase.co/functions/v1/paysera-callback',
      testMode: 'Test Mode',
      testModeHelp: 'Enable test mode to process payments in Paysera test environment',
      saving: 'Saving...',
      save: 'Save Paysera Settings',
      helpText: 'This data is required for Paysera payment processing. You can find the project ID and password in your Paysera administration panel. Test mode allows test payments.'
    },
    cache: {
      title: 'Cache-Control Settings',
      maxAge: 'Cache-Control max-age (seconds)',
      maxAgePlaceholder: '31536000',
      helpText: 'Set how long (in seconds) the browser should cache files. Recommended: 31536000 (1 year) for static files like product images. This reduces data usage and improves site performance.',
      timeUnits: {
        hour: '3600 = 1 hour',
        day: '86400 = 1 day',
        week: '604800 = 1 week',
        month: '2592000 = 1 month',
        year: '31536000 = 1 year (recommended)'
      },
      saving: 'Saving...',
      save: 'Save Cache-Control'
    },
    system: {
      title: 'System Status',
      productsCount: 'Products Count',
      usersCount: 'Users Count',
      database: 'Database',
      rlsEnabled: 'RLS Enabled',
      automaticallyUpdated: 'Automatically Updated',
      activeRoles: 'Active Roles',
      working: 'Working'
    },
    database: {
      title: 'Database Management',
      description: 'Database operations and maintenance are performed automatically.',
      updateCache: 'Update Product Cache',
      exportData: 'Export Data',
      diagnostics: 'System Diagnostics'
    },
    security: {
      title: 'Security Settings',
      description: 'Row Level Security (RLS) policies are active for all tables.',
      rlsProducts: 'RLS for Products',
      rlsOrders: 'RLS for Orders',
      rlsUsers: 'RLS for Users',
      active: 'Active'
    },
    actions: {
      title: 'Administrator Actions',
      description: 'Quick actions for system administration.',
      viewLogs: 'View System Logs',
      loading: 'Loading...',
      updateConfig: 'Update System Configuration',
      maintenanceMode: 'Toggle Maintenance Mode'
    },
    systemInfo: {
      title: 'System Information',
      version: 'Version:',
      databaseLabel: 'Database:',
      databaseValue: 'Supabase PostgreSQL',
      authentication: 'Authentication:',
      authenticationValue: 'Supabase Auth',
      lastUpdate: 'Last Update:',
      environment: 'Environment:',
      environmentValue: 'Production',
      region: 'Region:',
      regionValue: 'Europe'
    },
    logs: {
      title: 'System Logs',
      description: 'Recent system activity and events',
      noLogs: 'No logs available',
      orderCreated: 'Order created:',
      productUpdated: 'Product updated:'
    },
    toast: {
      saveSuccess: 'Saved',
      saveError: 'Save Error',
      saveErrorDescription: 'An error occurred while saving settings',
      emailEmpty: 'Email address cannot be empty',
      invalidEmail: 'Invalid email address',
      emailUpdated: 'Administrator email updated',
      emailDomainEmpty: 'Email domain cannot be empty',
      emailDomainUpdated: 'Email domain updated',
      contactUpdated: 'Contact settings updated',
      logoUpdated: 'Logo updated',
      titleUpdated: 'Site title updated',
      vatUpdated: 'VAT rate updated',
      sellerUpdated: 'Seller information updated',
      invoiceUpdated: 'Invoice settings updated',
      paymentMethodUpdated: 'Payment method updated',
      payseraFieldsRequired: 'Project ID and password are required',
      payseraUpdated: 'Paysera settings updated',
      cacheControlUpdated: 'Cache-Control settings updated',
      logLoadError: 'Error loading system logs'
    }
  },

  // Admin Orders
  adminOrders: {
    pageTitle: 'Order Management',
    ordersCount: 'Orders',
    searchPlaceholder: 'Search by number or ID...',
    filterPlaceholder: 'Filter by status',
    allStatuses: 'All statuses',
    createSupplierOrders: 'Create supplier orders',
    loading: 'Loading...',
    noOrdersFound: 'No orders found',
    noOrders: 'No orders',
    incompleteData: 'Incomplete data',
    // Table headers
    orderNumber: 'Order number',
    amount: 'Amount',
    status: 'Status',
    paymentStatus: 'Payment status',
    date: 'Date',
    actions: 'Actions',
    // Statuses
    statuses: {
      pending: 'Pending',
      processing: 'Processing',
      shipped: 'Shipped',
      delivered: 'Delivered',
      cancelled: 'Cancelled'
    },
    // Payment statuses
    paymentStatuses: {
      pending: 'Pending',
      paid: 'Paid',
      completed: 'Paid',
      succeeded: 'Paid',
      failed: 'Failed'
    },
    // Delivery methods
    deliveryMethods: {
      salonPickup: 'Salon pickup',
      salonPickupDesc: 'Products will be ready for pickup at the salon',
      parcelMachine: 'Omniva parcel machine',
      parcelMachineDesc: 'Delivery to selected Omniva parcel terminal',
      standardDelivery: 'Standard delivery',
      standardDeliveryDesc: 'Courier delivery to specified address',
      expressDelivery: 'Express delivery',
      expressDeliveryDesc: 'Delivery within 1-2 business days',
      defaultDeliveryDesc: 'Delivery to specified address'
    },
    // Delete confirmation
    deleteConfirmTitle: 'Are you sure you want to delete this order?',
    deleteConfirmDescription: 'This action cannot be undone. The order and all its items will be permanently deleted.',
    deleteButton: 'Delete',
    cancelButton: 'Cancel',
    // Order details dialog
    orderDetails: 'Order Details',
    editButton: 'Edit',
    saveButton: 'Save',
    // Customer information
    customerInfo: 'Customer Information',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    customerId: 'Customer ID',
    companyInfo: 'Company Information',
    companyCode: 'Company Code',
    vatCode: 'VAT Code',
    // Order information
    orderInfo: 'Order Information',
    orderId: 'Order ID',
    paymentMethod: 'Payment Method',
    selectPaymentMethod: 'Select payment method',
    createdAt: 'Created At',
    notes: 'Notes',
    // Payment methods
    paymentMethods: {
      cash: 'Cash',
      card: 'Bank card',
      bankTransfer: 'Bank transfer',
      other: 'Other'
    },
    // Shipping information
    shippingInfo: 'Shipping Information',
    trackingNumber: 'Tracking Number',
    trackingNumberPlaceholder: 'Enter tracking number',
    carrier: 'Carrier',
    selectCarrier: 'Select carrier',
    estimatedDelivery: 'Estimated Delivery',
    // Delivery information
    deliveryInfo: 'Delivery Information',
    email: 'Email',
    address: 'Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country',
    deliveryMethod: 'Delivery Method',
    noDeliveryInfo: 'No delivery information provided',
    omnivaLocation: 'Omniva Location',
    salonAddress: 'Pickup Address',
    salonName: 'Salon Name',
    // Order summary
    orderSummary: 'Order Summary',
    itemsValueBeforeDiscount: 'Items value (before discount):',
    loyaltyPointsUsed: 'Loyalty points',
    itemsValueAfterDiscount: 'Items value (after discount):',
    delivery: 'Delivery:',
    freeDelivery: 'Free',
    total: 'Total:',
    // Order items
    orderItems: 'Order Items',
    addItem: 'Add item',
    product: 'Product',
    brand: 'Brand',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    discount: 'Discount',
    itemTotal: 'Total',
    inSupplierOrder: 'In Supplier Order',
    included: 'Included',
    notIncluded: 'Not included',
    itemArrived: 'Item Arrived',
    noItems: 'No items',
    // Product search
    selectProduct: 'Select Product',
    selectProductDescription: 'Search and select a product to add to the order',
    searchProduct: 'Search product...',
    noProductsFound: 'No products found',
    productId: 'ID',
    // Supplier orders dialog
    supplierOrdersTitle: 'Supplier Orders',
    supplierOrdersDescription: 'Generated orders for suppliers based on selected customer orders',
    dateLabel: 'Date:',
    createAndSendOrders: 'Create and send orders to suppliers',
    noSupplierOrders: 'Could not create supplier orders',
    noItemsForSuppliers: 'All selected items are already included in supplier orders or do not have assigned suppliers.',
    missingInfoTitle: 'Missing Information',
    missingInfoDescription: 'These items cannot be included in supplier orders:',
    missingSupplier: 'No supplier assigned',
    missingUrl: 'No supplier link',
    orderRef: 'Ord.:',
    unknownSupplier: 'Unknown supplier',
    toast: {
      error: 'Error',
      success: 'Success',
      loadOrdersError: 'Failed to load orders',
      loadProductsError: 'Failed to load products',
      selectAtLeastOne: 'Select at least one order',
      generateError: 'Failed to generate supplier orders',
      loadItemsError: 'Failed to load order items',
      statusUpdated: 'Order status updated',
      statusUpdateError: 'Failed to update order status',
      orderDeleted: 'Order deleted',
      deleteError: 'Failed to delete order',
      orderUpdated: 'Order updated',
      updateError: 'Failed to update order',
      itemStatusError: 'Failed to update item status',
      itemStatusUpdated: 'Updated',
      itemArrivedUpdated: 'Item arrival status updated',
      supplierOrdersCreated: 'Supplier orders created',
      supplierOrdersError: 'Failed to create supplier orders',
      userNotLoggedIn: 'User not logged in'
    }
  },

  // Brands
  brands: {
    title: 'Brands',
    addBrand: 'Add brand',
    editBrand: 'Edit brand',
    searchPlaceholder: 'Search brands...',
    loading: 'Loading...',
    noBrands: 'No brands',
    noBrandsFound: 'No brands found',
    table: {
      logo: 'Logo',
      name: 'Name',
      description: 'Description',
      status: 'Status',
      sortOrder: 'Sort order',
      createdAt: 'Created',
      actions: 'Actions',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    deleteConfirm: {
      title: 'Delete brand?',
      description: 'Are you sure you want to delete the brand "{name}"? This action cannot be undone.',
      cancel: 'Cancel',
      delete: 'Delete',
    },
    toast: {
      loadError: 'Failed to load brands',
      deleted: 'Brand deleted',
      deletedDesc: 'Brand successfully deleted',
      deleteError: 'Failed to delete brand',
      activated: 'Brand activated',
      deactivated: 'Brand deactivated',
      statusChanged: 'Brand "{name}" {status}',
      statusError: 'Failed to change brand status',
    },
    form: {
      name: 'Name',
      nameRequired: 'Name *',
      namePlaceholder: 'Brand name',
      slug: 'URL slug',
      slugPlaceholder: 'brand-slug',
      description: 'Description',
      descriptionPlaceholder: 'Short brand description',
      logo: 'Logo',
      uploadLogo: 'Upload logo',
      logoPreview: 'Logo preview',
      websiteUrl: 'Website URL',
      websiteUrlPlaceholder: 'https://example.com',
      sortOrder: 'Sort order',
      isActive: 'Active',
      cancel: 'Cancel',
      save: 'Create',
      update: 'Update',
      saving: 'Saving...',
      nameRequiredError: 'Brand name is required',
      slugExistsError: 'A brand with this name already exists',
      created: 'Brand created',
      createdDesc: 'Brand "{name}" successfully created',
      updated: 'Brand updated',
      updatedDesc: 'Brand "{name}" successfully updated',
      createError: 'Failed to create brand',
      updateError: 'Failed to update brand',
    },
  },

  // Salon Locations
  salonLocations: {
    pageTitle: 'Salon Management',
    addSalon: 'Add Salon',
    noSalons: 'No salons',
    noSalonsDescription: 'Add your first salon so customers can choose a pickup location.',
    loading: 'Loading...',
    address: 'Address',
    phone: 'Phone',
    workingHours: 'Working Hours',
    active: 'Active',
    inactive: 'Inactive',
    confirmDelete: 'Are you sure you want to delete this salon?',
    toast: {
      loadError: 'Failed to load salons list',
      deleteSuccess: 'Salon deleted',
      deleteError: 'Failed to delete salon',
      error: 'Error',
      success: 'Success'
    },
    form: {
      editTitle: 'Edit Salon',
      newTitle: 'New Salon',
      nameLabel: 'Salon Name *',
      namePlaceholder: 'Beauty Salon "Bella"',
      cityLabel: 'City *',
      cityPlaceholder: 'Vilnius',
      addressLabel: 'Address *',
      addressPlaceholder: 'Gedimino pr. 1',
      postalCodeLabel: 'Postal Code',
      postalCodePlaceholder: '01103',
      phoneLabel: 'Phone',
      phonePlaceholder: '+370 600 12345',
      workingHoursLabel: 'Working Hours',
      workingHoursPlaceholder: 'Mon-Fri: 9:00-18:00, Sat-Sun: 10:00-16:00',
      isActiveLabel: 'Active Salon',
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      requiredFieldsError: 'Please fill in all required fields',
      updateSuccess: 'Salon information updated',
      createSuccess: 'New salon added',
      saveError: 'Failed to save salon information'
    }
  },
};
